<template>
  <v-data-iterator
    :items="['expense', 'income']"
    class="balance"
    content-tag="div"
    :content-class="'layout row wrap'"
    hide-actions
  >
    <template slot="header">
      <v-toolbar class="mb" color="primary" dark  flat>
        <!-- <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link> -->
        <v-toolbar-title class="font-weight-light headline">
          Balance Sheet
        </v-toolbar-title>

        <v-spacer></v-spacer>          
        <v-switch
          style="margin-top: 15px; font-weight-bold"
          v-model="isDepriciation"
          :label="`Depriciation: ${isDepriciation ? 'Yes' : 'No'}`"
        ></v-switch>

        <v-spacer></v-spacer>
        <v-btn icon dark @click="print()">
            <v-icon>print</v-icon>
        </v-btn>
        <router-link to="/Dashboard">
          <v-btn icon>
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </router-link>
      </v-toolbar>
        
      <v-toolbar class="mb" color="white white--text" flat>
        <v-layout row>
          <v-flex xs12 md4 sm4>
            <v-autocomplete
              dense 
              flat
              clearable
              item-text="name"
              :return-object="true"
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
            ></v-autocomplete>
          </v-flex>
          <v-spacer/>
          <v-flex xs12 md3 sm3>
              <v-menu
                :close-on-content-click="false"
                v-model="fromdatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceFrom"
                  single-line
                  label="From Date"
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceFrom" @input="fromdatepicker = false" />
              </v-menu>
            </v-flex>
            <v-spacer/>
            <v-flex xs12 md3 sm3>
            <v-menu
                :close-on-content-click="false"
                v-model="todatepicker"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <v-text-field
                  clearable
                  slot="activator"
                  v-model="filterInvoiceTo"
                  label="To Date"
                  single-line
                  readonly
                ></v-text-field>
                <v-date-picker v-model="filterInvoiceTo" @input="todatepicker = false" />
              </v-menu>
            </v-flex>
          </v-layout>
        </v-toolbar>
      </template>
      
      <template slot="item" slot-scope="props">
        <v-flex style="display: flex;flex-direction: column;" xs12 sm6 md v-if="props.item === 'expense'">
          <v-card>
            <v-card-title class="primary white--text"><span class="print-field">Liabilities</span> <v-spacer/> <span class="print-field">Amount</span></v-card-title>
            <v-divider />
            <v-list dense>
              <!-- <expand-card 
                v-if="selectedFirm"
                :value="propCapitalAC || 0 | amount"
                >
                <h3 slot="header">Prop capital A/C : </h3>
              </expand-card> --> 
            <v-card v-if="!!selectedFirm"> 
            <!-- <v-card-title >
              <b> Opening Stock</b>
              <v-spacer />
              <h3>{{ selectedFirmDetail.openingStock || 0 | amount}}</h3>
            </v-card-title> -->
          </v-card>

          <!-- Start of expense in prop Capital Account-->
              <div style="margin-top: -10px;">
              <!-- <expand-card
                :hasItems="groupExpensesOfPropCapital.length > 0"
                :value="propexpenseTotal  || 0 | amount"
              >  
                <template slot="header"> 
                  <b class="subheading font-weight-bold" v-if="groupExpensesOfPropCapital.length != 0">Expenses</b>
                  <b class="subheading font-weight-bold" v-if="groupExpensesOfPropCapital.length === 0">No Expense !</b>
                </template> -->
                
                <template slot="items">
                  <template v-for="(expense, e) in groupExpensesOfPropCapital" >
                  <v-expansion-panel-content v-if="expense.totalAmount > 0"
                    :key="e"
                  >
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <b class="primary--text font-weight-bold">{{ expense.expense }}</b> / {{ expense.category }}
                        <v-spacer />
                        <h3>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                      </v-card-title>
                    </v-card>
                  </div>
                    <v-list dense>
                    <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                      <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                      <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
                </template>
              </template>  
            <!-- </expand-card> --> 
          </div>
        <!-- End of Expense Account in Prop Capital account -->


        <!-- Start of Dep Asset in Prop capital Account   -->
        <v-expansion-panel expand>
            <v-expansion-panel-content :key="'12-a'">
              <!-- <div slot="header">
                <v-card>
                  <v-card-title>
                    <h3>Depriciation</h3>
                    <v-spacer />
                    <h3>{{ proptotalAsset || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div> -->
              <v-list dense>
                <v-list-tile v-for="(asset, i) in propassetByBrand" :key="i">
                  <v-list-tile-content>{{ asset.asset}}/ {{ asset.category }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ asset.depAmount || 0 | amount }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        <!-- End Of Depriciation Asset -->


        <!-- Purchase Stock --> 
          <v-card>
            <!-- <v-card-title>
              <b> Purchase</b>
              <v-spacer />
              <h3>{{ purchase | amount}}</h3>
            </v-card-title> -->
          </v-card>


        <!-- All Direct Expense -->   
          <div style="margin-top:3px;">
           <!-- <expand-card
            :hasItems="groupExpensesOfTradingAccount.length > 0"
            :value="tradingexpenseTotal || 0 | amount"
            >   -->
            <!-- <template slot="header"> 
              <h3 v-if="groupExpensesOfTradingAccount.length != 0">Expenses</h3>
              <h3 v-if="groupExpensesOfTradingAccount.length === 0">No Expense !</h3>
            </template> -->
            
            <template slot="items">
              <template v-for="(expense, e) in groupExpensesOfTradingAccount" >
                <v-expansion-panel-content v-if="expense.totalAmount > 0 || expense.openingBalance > 0"
                  :key="e"
                >
                <div slot="header">
                  <v-card>
                    <!-- <v-card-title>
                      <b>{{ expense.expense }}</b> / {{ expense.category }}
                      <v-spacer />
                      <h3>{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                    </v-card-title> -->
                  </v-card>
                </div>
                <v-list dense>
                  <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                    <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                    <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-' || 0 | amount}}</v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-expansion-panel-content>
            </template>
          </template>  
          <!-- </expand-card> -->
        </div>  
        <!-- End of Expense -->

        <v-card>
            <!-- <v-card-title v-if="grossProfit < 0">
              <b>Gross Loss c/d</b>
              <v-spacer />
              <h3>{{ grossProfit || 0 | amount}}</h3>
            </v-card-title> -->
        </v-card>
        <!-- Start of expense -->
          <div style="margin-top:3px;">
            <!-- <expand-card
              :hasItems="groupExpensesOfPandL.length > 0"
              :value="pandlexpenseTotal  || 0 | amount"
            >  
              <template slot="header"> 
                <h3 class="font-weight-bold" v-if="groupExpensesOfPandL.length != 0">Expenses</h3>
                <h3 class="font-weight-bold" v-if="groupExpensesOfPandL.length === 0">No Expense !</h3>
              </template> -->
            
              <template slot="items">
                <template v-for="(expense, e) in groupExpensesOfPandL" >
                  <v-expansion-panel-content v-if="expense.totalAmount > 0 || expense.openingBalance > 0"
                  :key="e">
                    <div slot="header">
                      <v-card>
                        <!-- <v-card-title>
                          <b class="primary--text font-weight-bold">{{ expense.expense }}</b> / {{ expense.category }}
                          <v-spacer />
                          <h3 class="primary--text font-weight-bold">{{ Number.parseFloat(expense.totalAmount) + Number.parseFloat(expense.openingBalance) || 0 | amount }}</h3>
                        </v-card-title> -->
                      </v-card>
                    </div>
                    <v-list dense>
                      <v-list-tile v-for="(section, i) in expense.invoices" :key="i">
                        <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                        <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </template>
              </template>  
            <!-- </expand-card> -->
          </div>
        <!-- End of Expense -->

        <!-- Start of Staff -->  
        <v-expansion-panel expand>
          <v-expansion-panel-content> 
            <!-- <div slot="header"> 
              <v-card>
                <v-card-title>
                  <b>Staff</b>
                  <v-spacer />
                  <h3>{{ totalSalary | amount }}</h3>
                </v-card-title>
              </v-card>  
            </div> -->
  
            <v-expansion-panel expand>
              <v-expansion-panel-content v-for="(staff, e) in getStaffAccount" :key="e">
                <div slot="header">
                  <v-card>
                    <!-- <v-card-title>
                      <b class="primary--text font-weight-bold">{{ staff.staffName }}</b> | {{ staff.staffRole }}
                      <v-spacer />
                      <h3 class="primary--text font-weight-bold">{{ staff.creditTotal - staff.debitTotal | amount }}</h3>
                    </v-card-title> -->
                  </v-card>
                </div>
                <!-- <v-data-table
                  :items="staff.salaryList"
                  class="elevation"
                  :headers="salaryListHeaders"
                  hide-actions
                > 
                  <template slot="items" slot-scope="props">
                    <td>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</td>   
                    <v-spacer/>             
                    <template v-if="props.item.isCredited">
                      <td><h4 class = "success--text align-end">₹ {{props.item.amount | amount}}</h4></td>
                    </template>
                    <v-spacer/>
                    <template v-if="!props.item.isCredited">
                      <td><h4 class = "error--text align-end"> ₹ {{props.item.amount | amount}}</h4></td>
                    </template>
                  </template>
                  <template slot="no-data">
                    no record found
                  </template>
                </v-data-table> -->
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panel-content>
        </v-expansion-panel> 
        <!-- End of Staff-->

        <!-- Depriciation Asset -->  
        <v-expansion-panel expand>
            <v-expansion-panel-content :key="'12-e'">
              <!-- <div slot="header">
                <v-card>
                  <v-card-title>
                    <b>Depriciation</b>
                    <v-spacer />
                    <h3>{{ pltotalAsset || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div> -->
              <v-list dense>
                <v-list-tile v-for="(asset, i) in plassetByBrand" :key="i">
                  <v-list-tile-content>{{ asset.asset}}/ {{ asset.category }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ asset.depAmount || 0 | amount }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
          </v-expansion-panel>
        <!-- End of Dep asset-->

        <!-- Start of net profit from profit and loss account -->
        <v-card>
            <!-- <v-card-title v-if="netProfit < 0">
              <b>Net Loss c/d</b>
              <v-spacer />
              <h3>{{ netProfit || 0 | amount}}</h3>
            </v-card-title> -->
        </v-card>
        <!-- End of net profit from profit and loss account -->

        <!-- Start Closing Balance of Prop Capital -->
          <v-card v-if="!!selectedFirm">
            <v-card-title>
              <b class="print-field">Prop Capital A/C</b>
              <v-spacer />
              <h3 class="print-field">{{ closingBalance || 0 | amount }}</h3>
            </v-card-title>
          </v-card>
        <!-- End of Closing Balance  of Prop capital Account-->
              
        <!-- New Development-->

        <!-- End of Loans -->
        <expand-card
          :hasItems="true"
          :value="securedLoansBankListTotal + totalLoan | amount"
        >  
          <template slot="header"> 
            <h3>Loans:</h3>
          </template>
            <template slot="items">
              <template :value="totalLoan || 0 | amount"
                :hasItems="sellerList.length > 0" >
                  <v-expansion-panel-content>
                    <div slot="header">
                      <v-card>
                        <v-card-title>
                          <b class="primary--text font-weight-bold print-field">Unsecured Loans:</b>
                          <v-spacer />
                          <b class="primary--text font-weight-bold print-field">{{totalLoan || 0 | amount}}</b>
                        </v-card-title>
                      </v-card>
                    </div>
              
                    <v-list dense>
                      <template v-for="creditor in sellerList.concat(buyerList)">
                        <v-list-tile v-if="!!creditor.totalLoanTaken" :key="creditor['.key']" >
                          <v-list-tile-content>
                            <h3 class="font-weight-bold">
                              <router-link  :to="{
                              path: `/buyers/${creditor['.key']}`
                              }">
                              <span class="print-field">{{creditor['name']}}</span>
                              </router-link>
                            </h3>
                          </v-list-tile-content>
                          <v-list-tile-content class="align-end print-field">{{creditor.totalLoanTaken || 0 | amount}}</v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-expansion-panel-content>
              </template>
              
              <template :value="securedLoansBankListTotal || 0 | amount"
                :hasItems="securedLoansBankList.length > 0" >
                <v-expansion-panel-content>
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <b class="primary--text font-weight-bold print-field">Secured Loans:</b>
                        <v-spacer />
                        <b class="primary--text font-weight-bold print-field">{{securedLoansBankListTotal || 0 | amount}}</b>
                      </v-card-title>
                    </v-card>
                  </div>
                  <v-list dense>
                    <template v-for="bank in securedLoansBankList" >
                      <v-list-tile v-bind:key="bank['.key']" >
                        <v-list-tile-content>
                          <span class="print-field">{{bank.bankName}}</span>
                          </v-list-tile-content>
                        <v-list-tile-content class="align-end"><span class="print-field">{{bank.amount || 0 | amount }}</span></v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>
          <!-- End of Loans -->

          <!-- Start of Long-term borrowings -->  
              <div style="margin-top:3px;">
                <expand-card
                  :hasItems="groupLiabilities.length > 0"
                  :value="liabilityTotal || 0 | amount"
                >  
                  <template slot="header"> 
                    <h3 v-if="groupLiabilities.length != 0">Long-term Borrowings</h3>
                    <h3 v-if="groupLiabilities.length === 0">No Long-term Borrowings</h3>
                  </template>
                  
                  <template slot="items">
                    <template v-for="(liability, e) in groupLiabilities" >
                    <v-expansion-panel-content v-if="(liability.totalAmount > 0 || liability.openingBalance > 0 ) && liability.underHead === 'Long-term Borrowing' "
                      :key="e"
                    >
                    <div slot="header">
                      <v-card>
                        <v-card-title>
                          <b class="primary--text font-weight-bold print-field">{{ liability.liability }}</b> 
                          <!-- / {{ liability.category }} -->
                          <v-spacer />
                          <b class="primary--text font-weight-bold print-field">{{ Number.parseFloat(liability.totalAmount) + Number.parseFloat(liability.openingBalance) || 0 | amount }}</b>
                        </v-card-title>
                      </v-card>
                    </div>
                  <v-list dense>
                      <v-list-tile v-for="(section, i) in liability.invoices" :key="i">
                        <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                        <v-list-tile-content class="align-end ">{{ section.totalAmount || section.openingBalance || '-' || 0 | amount}}</v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                  </template>
                  </template>  
                </expand-card>
              </div>
            <!-- End of Long-term borrowings -->

            <!-- Start of Short-term borrowings -->  
              <div style="margin-top:3px;">
                <expand-card
                  :hasItems="groupLiabilitiesShortTerm.length > 0"
                  :value="shortTermLiabilityTotal || 0 | amount"
                >  
                  <template slot="header"> 
                    <h3 v-if="groupLiabilitiesShortTerm.length != 0">short-term Borrowings</h3>
                    <h3 v-if="groupLiabilitiesShortTerm.length === 0">No short-term Borrowings</h3>
                  </template>
                  
                  <template slot="items">
                    <template v-for="(liability, e) in groupLiabilitiesShortTerm" >
                    <v-expansion-panel-content v-if="(liability.totalAmount > 0 || liability.openingBalance > 0 ) && liability.underHead === 'Short-Term Borrowing' "  
                      :key="e"
                    >
                    <div slot="header">
                      <v-card>
                        <v-card-title>
                          <b class="primary--text font-weight-bold print-field">{{ liability.liability }}</b> 
                          <!-- / {{ liability.category }} -->
                          <v-spacer />
                          <b class="primary--text font-weight-bold print-field">{{ Number.parseFloat(liability.totalAmount) + Number.parseFloat(liability.openingBalance) || 0 | amount }}</b>
                        </v-card-title>
                      </v-card>
                    </div>
                  <v-list dense>
                      <v-list-tile v-for="(section, i) in liability.invoices" :key="i">
                        <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                        <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || '-' || 0 | amount}}</span></v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                  </template>
                  </template>  
                </expand-card>
              </div>
          <!-- End of Short-term borrowings -->


          <!-- Start of Current Liabliities --> 
          <expand-card
            :hasItems="true"
            :value="(Number.parseFloat(liabilityTotalWPro) + Number.parseFloat(totalSundryCreditors) + Number.parseFloat(expenseProvisionTotal) + Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)) || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Current Liabilities:</h3>
            </template>
            
            <template slot="items">
              <template :value="liabilityTotalWPro || 0 | amount"
                :hasItems="liabilitiesWPro.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"><span class="print-field">Other Liabilities:</span></b>
                    <v-spacer />
                    <b class="primary--text font-weight-bold"><span class="print-field">{{liabilityTotalWPro || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="liability in liabilitiesWPro">
                <v-list-tile v-if="liability.paymentTypeStatus === 'yet to confirm'" v-bind:key="liability['.key']" >
                  <v-list-tile-content>
                   <span class="print-field">{{liability.liability}}</span>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    <!-- {{Number.parseFloat(liability.totalAmount + liability.openingBalance)}} -->
                  <b class="font-weight-bold"><span class="print-field"> {{ (Number.parseFloat(liability.totalAmount || 0 | amount) + Number.parseFloat(liability.openingBalance || 0 | amount )) || 0 | amount }}</span> </b>
                  </v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
              <template :value="totalSundryCreditors || 0 | amount"
                :hasItems="sellerList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"><span class="print-field">Sundry Creditors:</span></b>
                    <v-spacer />
                    <b class="primary--text font-weight-bold"><span class="print-field">{{totalSundryCreditors || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="creditor in sellerList" >
                <v-list-tile v-if="!!creditor.totalRemainingAmount" v-bind:key="creditor['.key']" >
                  <v-list-tile-content>
                     <b class="font-weight-bold">
                        <router-link  :to="{
                          path: `/buyers/${creditor['.key']}`
                        }">
                          <span class="print-field">{{creditor['name']}}</span>
                        </router-link> :
                      </b>
                  </v-list-tile-content>
                  <v-list-tile-content class="font-weight-bold align-end"><span class="print-field">{{creditor.totalRemainingAmount || 0 | amount}}</span></v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>

            <!-- Start of Expense Provision -->
            <template 
              :value="expenseProvisionTotal || 0 | amount"
              :hasItems="expenseWithProvision.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"><span class="print-field">Provisions:</span></b>
                    <v-spacer />
                    <b class="primary--text font-weight-bold"><span class="print-field">{{expenseProvisionTotal || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="expense in expenseWithProvision" >
                <v-list-tile v-if="expense.paymentTypeStatus === 'yet to confirm'" v-bind:key="expense['.key']" >
                  <v-list-tile-content>
                    <b class="font-weight-bold"><span class="print-field">{{expense.expense}}</span></b>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    <!-- {{expense.totalAmount}} -->
                   <b class="font-weight-bold"> <span class="print-field">{{ (Number.parseFloat(expense.totalAmount || 0 | amount) + Number.parseFloat(expense.openingBalance || 0 | amount )) || 0 | amount }} </span></b>
                  </v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
            <!-- End of Expense Provision -->
            
            <template 
                :value="(Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) || 0 | amount"
                :hasItems="true" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"><span class="print-field"> GST Liabilities:</span></b>
                    <v-spacer />
                    <b class="primary--text font-weight-bold"><span class="print-field">{{(Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="font-weight-bold"><span class="print-field">{{'IGST'}}</span></h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end"><span class="print-field">{{ITCData.liabilities.IGST || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="font-weight-bold"><span class="print-field">{{'CGST'}}</span></h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end"><span class="print-field">{{ITCData.liabilities.CGST || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <h3 class="font-weight-bold"><span class="print-field">{{'SGST'}}</span></h3>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end"><span class="print-field">{{ITCData.liabilities.SGST || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>

          <!-- End of Current Liabilitites-->
        
        <!-- End of New Developemt -->  




        <!-- Old Developent  -->

        <!-- Sundry  creditors -->      
              <!-- <expand-card 
                :value="totalSundryCreditors || 0 | amount"
                :hasItems="sellerList.length > 0"
                >
                <template slot="header">
                  <h3>Sundry Creditors: </h3>
                </template>
                <template slot="items">
                  <template v-for="creditor in sellerList">
                    <expand-card v-if="!!creditor.totalRemainingAmount"  :key="creditor['.key']"
                      :header="creditor.name"
                      :value="creditor.totalRemainingAmount"
                      containerClass="no-shadow"
                    >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">
                        <router-link  :to="{
                          path: `/buyers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                    </template>
                  </expand-card>
                  </template>
                </template>
              </expand-card> -->

              <!-- Unsecure Loans -->
              <!-- <expand-card 
                :value="totalLoan || 0 | amount"
                :hasItems="sellerList.length > 0"
                >
                <template slot="header">
                  <h3>Unsecured Loans: </h3>
                </template>
                <template slot="items">
                  <template v-for="creditor in sellerList.concat(buyerList)">
                  <expand-card v-if="!!creditor.totalLoanGiven" :key="creditor['.key']"
                    :header="creditor.name"
                    :value="creditor.totalLoanGiven"
                    containerClass="no-shadow"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">
                        <router-link  :to="{
                          path: `/buyers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                    </template>
                  </expand-card>
                </template>
                </template>
              </expand-card>

              <expand-card
                :value="securedLoansBankListTotal || 0 | amount"
                :hasItems="securedLoansBankList.length > 0"
                >
                <template slot="header">
                  <h3>Secured Loans (Bank Account) :</h3>
                </template>
                <template slot="items">
                  <expand-card v-for="bank in securedLoansBankList" v-bind:key="bank['.key']"
                    :header="bank.bankName" 
                    :value="bank.amount"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{bank.bankName}}</h3>
                    </template>
                  </expand-card>
                </template>
              </expand-card> -->


            <!-- provision expense -->
              <!-- <expand-card
                :value="expenseProvisionTotal || 0 | amount"
                :hasItems="expenseWithProvision.length > 0"
                >
                <template slot="header">
                  <h3> Provisions:</h3>
                </template>
               
                <template slot="items">
                  <template v-for="expense in expenseWithProvision">
                  <expand-card v-if="expense.paymentTypeStatus === 'yet to confirm'" v-bind:key="expense['.key']"
                    :header="expense.expense" 
                    :value="(Number.parseFloat(expense.totalAmount || 0 | amount) + Number.parseFloat(expense.openingBalance || 0 | amount ))"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{expense.expense}}</h3>
                    </template>
                  </expand-card>
                  </template>
                </template>
              </expand-card> -->
              
              <!-- Liabilities With Provision -->
              
              <!-- provision expense -->
              <!-- <expand-card
                :value="liabilityTotalWPro || 0 | amount"
                :hasItems="liabilitiesWPro.length > 0"
                >
                <template slot="header">
                  <h3> Current Liabilities:</h3>
                </template>
               
                <template slot="items">
                  <template v-for="liability in liabilitiesWPro">
                  <expand-card v-if="liability.paymentTypeStatus === 'yet to confirm'" v-bind:key="liability['.key']"
                    :header="liability.liability" 
                    :value="(Number.parseFloat(liability.totalAmount || 0 | amount) + Number.parseFloat(liability.openingBalance || 0 | amount ))"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{liability.liability}}</h3>
                    </template>
                  </expand-card>
                  </template>
                </template>
              </expand-card>

              <expand-card
                :value="(Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)).toFixed(2) || 0 | amount"
                :hasItems="true"
                >
                <template slot="header">
                  <h3> GST Liabilities:</h3>
                </template>
               
                  <template slot="items">
                  <expand-card 
                    :header="'IGST'" 
                    :value="ITCData.liabilities.IGST"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{'IGST'}}</h3>
                    </template>
                  </expand-card>
                   <expand-card 
                    :header="'CGST'" 
                    :value="ITCData.liabilities.CGST"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{'CGST'}}</h3>
                    </template>
                  </expand-card>
                   <expand-card 
                    :header="'SGST'" 
                    :value="ITCData.liabilities.SGST"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{'SGST'}}</h3>
                    </template>
                  </expand-card>
                  </template>
              </expand-card> -->

              <!-- End of Left Side Content --> 
            </v-list>
          </v-card>

          <!-- Liabilities i.e Left side Total -->
          <v-card style="margin-top: auto;">
            <v-card-title class="primary white--text">
              <span class="print-field">Total </span>
              <v-spacer />
              <h2><span class="print-field">{{ ((totalSundryCreditors + totalLoan + securedLoansBankListTotal) + Number.parseFloat(liabilityTotalWPro) + Number.parseFloat(closingBalance) + Number.parseFloat(expenseProvisionTotal) + Number.parseFloat(shortTermLiabilityTotal) + Number.parseFloat(liabilityTotal) + Number.parseFloat(ITCData.liabilities.IGST) + Number.parseFloat(ITCData.liabilities.SGST) + Number.parseFloat(ITCData.liabilities.CGST)) || 0 | amount }}</span></h2>
            </v-card-title>
            <v-divider />
          </v-card>
        </v-flex>


        <!-- second side -->
        <v-flex xs12 sm6 md v-if="props.item === 'income'">
          <v-card style=" display: flex;flex-direction: column;">
            <v-card-title class="primary white--text"><span class="print-field">Assets</span> <v-spacer/> <span class="print-field">Amount</span></v-card-title>
            <v-divider />
          </v-card>
          

          <!-- Start of Opening Balance in Prop Capital Account --> 
          <v-card v-if="!!selectedFirm"> 
            <!-- <v-card-title>
              <b> Opening Balance</b>
              <v-spacer />
              <h3>{{ selectedFirmDetail.openingBalance || 0 | amount}}</h3>
            </v-card-title> -->
          </v-card>
          <!-- End of Opening Balance in Prop Capital Account --> 
          
          <!-- Start Of Income in Prop Capital -->
          <div style="margin-top:3px;">
            <!-- <expand-card
              :hasItems="groupIncomesOfPropCapital.length > 0"
              :value="propincomeTotal || 0 | amount"
            >  
            <template slot="header"> 
              <b class="subheading font-weight-bold" v-if="groupIncomesOfPropCapital.length != 0">Incomes</b>
              <b class="subheading font-weight-bold" v-if="groupIncomesOfPropCapital.length === 0">No Other Income !</b>
            </template> -->
            
            <template slot="items">
              <template v-for="(income, e) in groupIncomesOfPropCapital" >
                <v-expansion-panel-content :key="e">
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <b class="primary--text font-weight-bold print-field">{{ income.income }}</b> / {{ income.category }}
                        <v-spacer />
                        <h3 class="primary--text font-weight-bold  print-field">{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</h3>
                      </v-card-title>
                    </v-card>
                  </div>
                  <v-list dense>
                    <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                      <v-list-tile-content> <span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                      <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || 0 | amount}}</span></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          <!-- </expand-card> -->
        </div>
        <!-- End of Income in Prop Capital -->

        <!-- Sale Details -->  
        <v-card>
            <!-- <v-card-title>
              <b>Sales</b>
              <v-spacer />
              <h3>{{ sales | amount}}</h3>
            </v-card-title> -->
        </v-card>


        <!-- Start Income List -->
        <div style="margin-top:3px;">
          <!-- <expand-card
            :hasItems="groupIncomesOfTradingAccount.length > 0"
            :value="tradingincomeTotal || 0 | amount"
          >   -->
            <!-- <template slot="header"> 
              <h3 class="subheading font-weight-bold" v-if="groupIncomesOfTradingAccount.length != 0">Incomes</h3>
              <h3 class="subheading font-weight-bold" v-if="groupIncomesOfTradingAccount.length === 0">No Other Income !</h3>
            </template> -->
            
            <template slot="items">
              <template v-for="(income, e) in groupIncomesOfTradingAccount" >
                <v-expansion-panel-content  v-if="income.totalAmount > 0 || income.openingBalance > 0" :key="e">
                  <div slot="header">
                    <v-card>
                      <!-- <v-card-title>
                        <b class="primary--text font-weight-bold">{{ income.income }}</b> / {{ income.category }}
                        <v-spacer />
                        <h3 class="primary--text font-weight-bold">{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</h3>
                      </v-card-title> -->
                    </v-card>
                  </div>
                  <v-list dense>
                    <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                      <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                      <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || 0 | amount}}</span></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          <!-- </expand-card> -->
        </div>
        
        <v-card>
            <!-- <v-card-title v-if="grossProfit >= 0">
              <b>Gross Profit c/d</b>
              <v-spacer />
              <h3>{{ grossProfit || 0 | amount }}</h3>
            </v-card-title> -->
          </v-card>
          <div style="margin-top:3px;">
            <!-- <expand-card
              :hasItems="groupIncomesOfPl.length > 0"
              :value="pandlincomeTotal || 0 | amount"
            >   
              <template slot="header"> 
                <b class="subheading font-weight-bold" v-if="groupIncomesOfPl.length != 0">Incomes</b>
                <b class="subheading font-weight-bold" v-if="groupIncomesOfPl.length === 0">No Other Income !</b>
              </template> -->
            
              <template slot="items">
                <template v-for="(income, e) in groupIncomesOfPl" >
                  <v-expansion-panel-content  v-if="income.totalAmount > 0 || income.openingBalance >0 " :key="e">
                    <div slot="header">
                      <v-card>
                        <!-- <v-card-title>
                          <b>{{ income.income }}</b> / {{ income.category }}
                          <v-spacer />
                          <h3>{{ Number.parseFloat(income.totalAmount) + Number.parseFloat(income.openingBalance) || 0 | amount }}</h3>
                        </v-card-title> -->
                      </v-card>
                    </div>
                    <v-list dense>
                      <v-list-tile v-for="(section, i) in income.invoices" :key="i">
                        <v-list-tile-content><span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                        <v-list-tile-content class="align-end"><span class="print-field">{{ section.totalAmount || section.openingBalance || 0 | amount}}</span></v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-expansion-panel-content>
                </template>
              </template>  
            <!-- </expand-card> -->
        </div>

        <!-- Net profit -->  
        <v-card>
            <!-- <v-card-title v-if="netProfit >=  0">
              <b>Net profit c/d</b>
              <v-spacer />
              <h3>{{ netProfit || 0 | amount}}</h3>
            </v-card-title> -->
        </v-card>
        <!-- End Of Net profit -->

        <v-list dense>
          <!-- <expand-card 
                :value="totalSundryDebitors || 0 | amount"
                :hasItems="buyerList.length > 0"
                >
                <template slot="header">
                  <h3>Sundry Debtors: </h3>
                </template>
                <template slot="items">
                  <template  v-for="creditor in buyerList">
                  <expand-card v-if="!!creditor.totalRemainingAmount" :key="creditor['.key']"
                    :header="creditor.name"
                    :value="creditor.totalRemainingAmount"
                    containerClass="no-shadow"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">
                        <router-link  :to="{
                          path: `/buyers/${creditor['.key']}`
                        }">
                          {{creditor['name']}}
                        </router-link> :
                      </h3>
                    </template>
                  </expand-card>
                </template>
              </template>
          </expand-card> -->

          <!-- Loans and Advances -->
          <expand-card 
                :value="totalLoanAndAdvances || 0 | amount"
                :hasItems="buyerList.length > 0"
                >
                <template slot="header">
                  <h3>Loans & Advances :</h3>
                </template>
                <template slot="items">
                  <template v-for="creditor in buyerList.concat(sellerList)">
                  <expand-card v-if="!!creditor.totalLoanGiven" :key="creditor['.key']"
                    :header="creditor.name"
                    :value="creditor.totalLoanGiven"
                    containerClass="no-shadow"
                    class="primary--text font-weight-bold"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">
                        <router-link  :to="{
                          path: `/buyers/${creditor['.key']}`
                        }">
                        {{creditor['name']}} :
                        </router-link>
                      </h3>
                    </template>
                  </expand-card>
                </template>
              </template>  
          </expand-card>

          <!-- New Development Asset Side-->
          <!-- Fixed Assets -->  
          <expand-card
            :hasItems="getAssetAccount.length > 0"
            :value="totalAssetAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Fixed Asset:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getAssetAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type != 'investments'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"> <span class="print-field">{{ asset.details.asset }}</span></b> 
                    <!-- / {{ asset.details.category }} {{ asset.details.type }} -->
                    <v-spacer />
                    <!-- <h3>{{ ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * (isDepriciation ? asset.details.depriciation : 0)) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )  }}</h3> -->
                    <b class="primary--text font-weight-bold"> <span class="print-field">{{ (((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * asset.details.depriciation) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )) || 0 | amount  }}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content> <span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                  <v-list-tile-content class="align-end"> <span class="print-field">{{ section.totalAmount || section.openingBalance || '-' || 0 | amount}}</span></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>


          <!-- Intangible Assets -->
          <expand-card
            :hasItems="getIntangibleAssetAccount.length > 0"
            :value="totalIntangibleAssetAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Intangible asset:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getIntangibleAssetAccount" >
                <v-expansion-panel-content 
                  v-if="asset.details.type === 'intangibleAssets'"
                  v-bind:key="e"
                >
                  <div slot="header">
                    <v-card>
                      <v-card-title>
                        <b class="primary--text font-weight-bold"> <span class="print-field">{{ asset.details.asset }}</span></b> 
                        <!-- / {{ asset.details.category }} {{ asset.details.type }} -->
                        <v-spacer />
                        <!-- <h3>{{ Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0 | amount }}</h3> -->
                        <b class="primary--text font-weight-bold"> <span class="print-field">{{ (((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * asset.details.depriciation) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )) || 0 | amount  }}</span></b>
                      </v-card-title>
                    </v-card>
                  </div>
                  <v-list dense>
                    <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                      <v-list-tile-content> <span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                      <v-list-tile-content class="align-end"> <span class="print-field">{{ section.totalAmount || section.openingBalance || '-' || 0 | amount}}</span></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-expansion-panel-content>
              </template>
            </template>  
          </expand-card>

          <!-- Investment Assets -->
          <expand-card
            :hasItems="getInvestmentAccount.length > 0"
            :value="totalInvestmentAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Investments:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getInvestmentAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type === 'investments'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"> <span class="print-field">{{ asset.details.asset }}</span></b> 
                    <!-- / {{ asset.details.category }} {{ asset.details.type }} -->
                    <v-spacer />
                    <b class="primary--text font-weight-bold"> <span class="print-field">{{ (Number.parseFloat(asset.details.totalAmount || 0 | amount)) + (Number.parseFloat(asset.details.openingBalance) || 0 | amount) || 0 | amount }}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content> <span class="print-field">{{ new Date(section.date).toLocaleDateString('en-GB')  }}</span></v-list-tile-content>
                  <v-list-tile-content class="align-end"> <span class="print-field">{{ section.totalAmount || section.openingBalance || '-' || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>


          <!-- Current Assets -->  
          <expand-card
            :hasItems="true"
            :value="(Number.parseFloat(totalSundryDebitors) + Number.parseFloat(incomeProvisionTotal) + Number.parseFloat(savingsCurrentBankListTotal)+ Number.parseFloat(cashInHand)+Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST) + Number.parseFloat((isJwelleryBussiness
                  ? closingStockWeight
                  : closingStock))).toFixed(2) || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Current Assets:</h3>
            </template>

          <!-- Start of closing Stock -->
          <!-- <template 
              :value="closingStock || 0 | amount"
              :hasItems="false" >
              <v-expansion-panel-content>
                <div slot="header">
                  <v-card>
                    <v-card-title>
                      <b class="primary--text font-weight-bold">Closing Stock :</b>
                        <v-spacer />
                        <h3>{{closingStock || 0 | amount}}</h3>
                    </v-card-title>
                  </v-card>
                </div>
              </v-expansion-panel-content>
            </template> -->
          <!-- End of Closing Stock -->
            
          <template slot="items">
              <template :value="totalSundryDebitors || 0 | amount"
                :hasItems="buyerList.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"> <span class="print-field">Sundry Debtors:</span></b>
                    <v-spacer />
                    <b class="primary--text font-weight-bold"> <span class="print-field">{{totalSundryDebitors || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="creditor in buyerList">
                <v-list-tile v-if="!!creditor.totalRemainingAmount" :key="creditor['.key']" >
                  <v-list-tile-content>
                   <b class="primary--text font-weight-bold">
                        <router-link  :to="{
                          path: `/buyers/${creditor['.key']}`
                        }">
                           <span class="print-field">{{creditor['name']}} :</span>
                        </router-link>
                      </b>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end"><span class="print-field">{{creditor.totalRemainingAmount || 0 | amount}}</span></v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>

            <!-- Start of income Provision -->
            <template 
              :value="incomeProvisionTotal || 0 | amount"
              :hasItems="incomesWPro.length > 0" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"><span class="print-field">Provisions:</span></b>
                    <v-spacer />
                    <b class="primary--text font-weight-bold"><span class="print-field">{{incomeProvisionTotal || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <template v-for="income in incomesWPro" >
                <v-list-tile v-if="income.paymentTypeStatus === 'yet to confirm'" v-bind:key="income['.key']" >
                  <v-list-tile-content>
                    <b class="font-weight-bold"><span class="print-field">{{income.income}}</span></b>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end">
                    <!-- {{income.totalAmount}} -->
                   <b class="font-weight-bold"> <span class="print-field">{{ (Number.parseFloat(income.totalAmount || 0 | amount) + Number.parseFloat(income.openingBalance || 0 | amount )) || 0 | amount }} </span></b>
                  </v-list-tile-content>
                </v-list-tile>
                </template>
              </v-list>
            </v-expansion-panel-content>
            </template>
            <!-- End of income Provision -->

            <template 
              :value="savingsCurrentBankListTotal || 0 | amount"
              :hasItems="savingsCurrentBankList.length > 0" >
              <v-expansion-panel-content>
                <div slot="header">
                  <v-card>
                    <v-card-title>
                      <b class="primary--text font-weight-bold"><span class="print-field">Bank Account :</span></b>
                      <v-spacer />
                      <b class="primary--text font-weight-bold"><span class="print-field">{{savingsCurrentBankListTotal || 0 | amount}}</span></b>
                    </v-card-title>
                  </v-card>
                </div>
                <v-list dense>
                  <template v-for="bank in savingsCurrentBankList" >
                    <v-list-tile  v-bind:key="bank['.key']">
                      <v-list-tile-content>
                        <template><b class="font-weight-bold"><span class="print-field">{{bank.bankName}}</span></b></template>
                      </v-list-tile-content>
                      <v-list-tile-content class="align-end">
                       <b class="font-weight-bold"><span class="print-field"> {{bank.amount || 0 | amount}} </span></b>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </template>
            
            <template 
              :value="cashInHand || 0 | amount"
              :hasItems="false" >
              <v-expansion-panel-content>
                <div slot="header">
                  <v-card>
                    <v-card-title>
                      <b class="primary--text font-weight-bold"><span class="print-field">Cash in Hand :</span></b>
                        <v-spacer />
                        <b class="primary--text font-weight-bold"><span class="print-field">{{cashInHand || 0 | amount}}</span></b>
                    </v-card-title>
                  </v-card>
                </div>
              </v-expansion-panel-content>
            </template>
            
            <template :value="(Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount"
                :hasItems="true" >
              <v-expansion-panel-content 
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold"> <span class="print-field">GST Assets:</span></b>
                    <v-spacer />
                    <b class="align-end primary--text font-weight-bold"><span class="print-field">{{(Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount}}</span></b>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>
                      <b class="font-weight-bold"><span class="print-field">{{'IGST'}}</span></b>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end font-weight-bold "><span class="print-field">{{ITCData.assets.IGST || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <b class="font-weight-bold"><span class="print-field">{{'CGST'}}</span></b>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end font-weight-bold"><span class="print-field">{{ITCData.assets.CGST || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>
                      <b class="font-weight-bold"><span class="print-field">{{'SGST'}}</span></b>
                  </v-list-tile-content>
                  <v-list-tile-content class="align-end font-weight-bold"><span class="print-field">{{ITCData.assets.SGST || 0 | amount }}</span></v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
                   <template 
              :value="(isJwelleryBussiness
                  ? closingStockWeight
                  : closingStock) || 0 | amount"
              :hasItems="filteredProduct.length > 0" >
              <v-expansion-panel-content>
                <div slot="header">
                  <v-card>
                    <v-card-title>
                      <b class="primary--text font-weight-bold"><span class="print-field">Closing Stock :</span></b>
                      <v-spacer />
                      <b class="primary--text font-weight-bold"><span class="print-field">{{(isJwelleryBussiness
                  ? closingStockWeight
                  : closingStock) || 0 | amount}}</span></b>
                    </v-card-title>
                  </v-card>
                </div>
                <v-list dense>
                  <template v-for="(prod2, e) in (isJwelleryBussiness
                  ? filteredGroups
                  : filteredProduct)" >
                    <v-list-tile  :key="e+'pcC'">
                      <v-list-tile-content>
                        <template><b class="font-weight-bold"><span class="print-field">{{prod2.name}}</span></b></template>
                      </v-list-tile-content>
                      <v-list-tile-content class="align-end">
                       <b class="font-weight-bold"><span class="print-field"> {{prod2.closingAmount || 0| amount}}</span> </b>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
              </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card>

          <!-- end of New Developemt Asset Side -->          
          
          
          <!-- <expand-card 
            :value="savingsCurrentBankListTotal || 0 | amount"
            :hasItems="savingsCurrentBankList.length > 0"
            >
            <template slot="header"><h3>Bank Account : </h3></template>
            <template slot="items">
              <expand-card v-for="bank in savingsCurrentBankList" v-bind:key="bank['.key']"
                :value="bank.amount"
              >
                <template slot="header"><h3 class="primary--text font-weight-bold">{{bank.bankName}}</h3></template>
              </expand-card>
            </template>
          </expand-card> -->

          <!-- Fixed Assets -->  
          <!-- <expand-card
            :hasItems="getAssetAccount.length > 0"
            :value="totalAssetAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Fixed Asset:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getAssetAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type != 'investments'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold">{{ asset.details.asset }}</b> / {{ asset.details.category }} {{ asset.details.type }}
                    <v-spacer />
                    <h3>{{ ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) -  Number.parseFloat(((asset.details.totalAmount + asset.details.openingBalance)  * asset.details.depriciation) / 100) || 0 | amount ) || ((Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance)) || 0 | amount )  }}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card> -->

          <!-- Investment Assets -->
          <!-- <expand-card
            :hasItems="getInvestmentAccount.length > 0"
            :value="totalInvestmentAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3> investments:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getInvestmentAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type === 'investments'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold">{{ asset.details.asset }}</b> / {{ asset.details.category }} {{ asset.details.type }}
                    <v-spacer />
                    <h3>{{ Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card> -->

          <!-- Intangible Assets -->
          <!-- <expand-card
            :hasItems="getIntangibleAssetAccount.length > 0"
            :value="totalIntangibleAssetAmount || 0 | amount"
          >  
            <template slot="header"> 
              <h3>Intangible asset:</h3>
            </template>
            
            <template slot="items">
              <template v-for="(asset, e) in getIntangibleAssetAccount" >
              <v-expansion-panel-content 
                v-if="asset.details.type === 'intangibleAssets'"
                v-bind:key="e"
              >
              <div slot="header">
                <v-card>
                  <v-card-title>
                    <b class="primary--text font-weight-bold">{{ asset.details.asset }}</b> / {{ asset.details.category }} {{ asset.details.type }}
                    <v-spacer />
                    <h3>{{ Number.parseFloat(asset.details.totalAmount) + Number.parseFloat(asset.details.openingBalance) || 0 | amount }}</h3>
                  </v-card-title>
                </v-card>
              </div>
              <v-list dense>
                <v-list-tile v-for="(section, i) in asset.invoices" :key="i">
                  <v-list-tile-content>{{ new Date(section.date).toLocaleDateString('en-GB')  }}</v-list-tile-content>
                  <v-list-tile-content class="align-end">{{ section.totalAmount || section.openingBalance || '-'}}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-expansion-panel-content>
            </template>
            </template>  
          </expand-card> -->


          <!-- Cash in Hand -->
          <!-- <expand-card :value="cashInHand || 0 | amount">
            <template slot="header"><h3>Cash in Hand : </h3></template>
          </expand-card> -->

          <!-- GST Assets -->
          <!-- <expand-card
            :value="(Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)).toFixed(2) || 0 | amount"
            :hasItems="true"
            >
              <template slot="header">
                <h3> GST Assets:</h3>
              </template>
                <template slot="items">
                  <expand-card 
                    :header="'IGST'" 
                    :value="ITCData.assets.IGST"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{'IGST'}}</h3>
                    </template>
                  </expand-card>
                  <expand-card 
                    :header="'CGST'" 
                    :value="ITCData.assets.CGST"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{'CGST'}}</h3>
                    </template>
                  </expand-card>
                  <expand-card 
                    :header="'SGST'" 
                    :value="ITCData.assets.SGST"
                  >
                    <template slot="header">
                      <h3 class="primary--text font-weight-bold">{{'SGST'}}</h3>
                    </template>
                  </expand-card>
                </template>
              </expand-card> -->

          
        </v-list> 

        <!-- Total Right side -->
        <v-card  style="margin-top: auto;">
            <v-spacer/>
            <v-card-title 
              class="primary white--text">
                <span class="print-field">Total</span>
                <v-spacer />
              <h2><span class="print-field">{{ Number.parseFloat(cashInHand + savingsCurrentBankListTotal + totalSundryDebitors  + totalLoanAndAdvances + totalInvestmentAmount + totalAssetAmount + totalIntangibleAssetAmount + Number.parseFloat(incomeProvisionTotal) + Number.parseFloat(ITCData.assets.IGST) + Number.parseFloat(ITCData.assets.SGST) + Number.parseFloat(ITCData.assets.CGST)) + Number.parseFloat((isJwelleryBussiness
                  ? closingStockWeight
                  : closingStock)) || 0 | amount }}</span></h2>
              <!-- <h2> {{ closingStock || 0 | amount }} </h2> -->
              </v-card-title> 
          </v-card>
       </v-flex>
      </template>
    </v-data-iterator>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
import {convertToPDFBalanceSheet } from "../../../utils/pdf-reports/information-reports";
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

import ExpandCard from './expandCard';

  export default {
    components: {
      ExpandCard,
    },
    watch: {
    selectedFirm(nval, oval) {
        if (oval !== nval) {
        this.getData();
        }
      },
    },
    created() {
      this.$bindAsArray('invoices', this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('expenses', this.$root.$firebaseRefs.expenses.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('incomes', this.$root.$firebaseRefs.incomes.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('liabilities', this.$root.$firebaseRefs.liabilities.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('assets', this.$root.$firebaseRefs.assets.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('firms', this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('accounts', this.$root.$firebaseRefs.account.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('buyers', this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('sellers', this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray("customerDeposit",  this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('salarys', this.$root.$firebaseRefs.salarys.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray('staff',this.$root.$firebaseRefs.staff.orderByChild('brand').equalTo(this.selectedBrand))
      this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
       this.$bindAsArray("firmSettings", this.$root.$firebaseRefs.firmSettings.orderByChild('brand').equalTo(this.selectedBrand));
           this.$bindAsArray(
      "productGroups",
      this.$root.$firebaseRefs.productGroup
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
      this.getData();
    },
    computed: {
      ...mapGlobalGetters(['selectedBrand','finYear',"brandFinYear"]),
      firmStockReportType(){
        let val = 'APP'
        if(this.selectedFirm) {
          let dfirmSetting = this.firmSettings.filter(item => item['firm'] == this.selectedFirm['.key'])[0];
          if(dfirmSetting && dfirmSetting.stockReportView) {
            val = dfirmSetting.stockReportView
          }
        }
        return val;
      },
      selectedFirmDetail() {
        if(!this.selectedFirm) { return null }
        return this.firms.find(item => item['.key'] === this.selectedFirm['.key'])
      },
      filteredProduct() {
      let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
      let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
      let products = this.productList.filter(item => item['brand'] === this.selectedBrand &&
      (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true));
      let total = {
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0
      }
      products.map((p,index) => {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["stockReportData"] = {
        saleDetails : [],
        purchaseDetails : [],
        lastSalePrice : 0,
          lastPurchasePrice : 0
        } 
         let prodG = {
          weight: 0,
          openingBalance: 0,
        };
        if (this.isJwelleryBussiness) {
          if (p.productGroup) {
            prodG = this.productGroups.find(
              (item) => item[".key"] == p.productGroup
            );
          }
          products[index]["openingQuantity"] = Number.parseFloat(
            (prodG && prodG.weigh ? prodG.weight  : 0)
          );
          products[index]["openingBalance"] = Number.parseFloat(
            (prodG && prodG.openingBalance ? prodG.openingBalance  : 0)
          );
        } else {
          products[index]["openingQuantity"] = 0;
          products[index]["openingBalance"] = 0;
        }
        if(p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            // quantity : Number.parseFloat(p.openingQuantity),
            // rate : Number.parseInt(p.openingBalance),
            quantity : Number.parseInt(p.openingQuantity),
            rate : (Number.parseFloat(p.openingBalance)/ Number.parseInt(p.openingQuantity)),
            date: p.openingDate
          })
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += parseInt(p["openingQuantity"] ? p["openingQuantity"] : 0)
        total.openingBalance +=  Number.parseFloat(p["openingBalance"] ? p["openingBalance"] : 0)
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      let latestSaleDate = new Date('01-01-1000').getTime();
      let latestPurchaseDate = new Date('01-01-1000').getTime();
      let filteredInvoices = this.invoices.filter(item => (      
      (item.type != "automatic invoice") &&
      (item.items && item.items.length) &&
      (item.date >= this.finYear.start) && 
      (item.deleted != true) &&
      (item.date <= this.finYear.end) &&
      (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
      (fromDate ? item.date >= fromDate : true) &&
      (toDate ? item.date <= toDate : true)));
      this.selectProdList = [];
      filteredInvoices.map(invoice => {
        let invoiceMonth = new Date(invoice.date).getMonth();
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if(productGroup[item["productId"]]) {
                 if (
                productGroup[item["productId"]][0].durationQuantity != undefined
              ) {
                let durationQuantity = parseInt(
                  productGroup[item["productId"]][0]["durationQuantity"]
                );
                durationQuantity += !!isBuyer
                  ? -parseInt(item.quantity)
                  : parseInt(item.quantity);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = durationQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
                  total.durationQuantity += parseInt(productGroup[item["productId"]][0][
                  "durationQuantity"
                ]);
              }
              let rate = (Number.parseFloat(item.rate));
              if(isBuyer) {
                if(invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              } else {
                if(invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              }
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer
                ? -Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue)
                : Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0][
                  "durationQtySale"
                ] += parseInt(item.quantity);
                total.durationQtySale += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountSale"
                ] += (Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue));
                total.durationAmountSale += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              } else {
                productGroup[item["productId"]][0][
                  "durationQtyPurchase"
                ] += parseInt(item.quantity);
                total.durationQtyPurchase += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountPurchase"
                ] += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
                total.durationAmountPurchase += Number.parseFloat(item.basicPrice) + Number.parseFloat(item.GSTValue);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance']
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity']
              if(!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length))
                productGroup[item["productId"]][0]['productList'] = [];

              productGroup[item["productId"]][0]['productList'].push(item)
              }
              
            });
      });
      // productGroup['total'] = [{
      //   name : 'Total',
      //   ".key" : 'total',
      //   quantity : total.quantity,
      //   durationQuantity : total.durationQuantity,
      //   durationAmount : total.durationAmount,
      //   saleQuantity : total.saleQuantity,
      //   durationQtySale : total.durationQtySale,
      //   durationAmountSale : total.durationAmountSale,
      //   purchaseQuantity : total.purchaseQuantity,
      //   durationQtyPurchase : total.durationQtyPurchase,
      //   durationAmountPurchase : total.durationAmountPurchase,
      //   openingQuantity : total.openingQuantity,
      //   openingBalance : total.openingBalance
      // }];
      let results = [];
      this.closingStock = 0;
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map((key, index)=> {
          productGroup[key][".key"] = key;
          results.push(productGroup[key][0]);
          // productGroup[key][0]['closingAmount'] = this.getClosingAmount(productGroup[key][0]);
          let temp = this.getClosingAmount(productGroup[key][0]);
          productGroup[key][0]['closingAmount'] = isNaN(temp) ? 0 : temp;
          this.closingStock += Number.parseFloat(productGroup[key][0]['closingAmount'])
        });
         
      return results;
    },
        filteredGroups() {
      let products = Object.assign([], this.filteredProduct);
      //let total = products.pop();
      let groups = JSON.parse(JSON.stringify(this.productGroups));
      groups.push({
        name: "Non group Products",
        ".key": "Nongroup",
        quantity: 0,
        durationQuantity: 0,
        durationAmount: 0,
        saleQuantity: 0,
        durationQtySale: 0,
        durationAmountSale: 0,
        purchaseQuantity: 0,
        durationQtyPurchase: 0,
        durationAmountPurchase: 0,
        openingQuantity: 0,
        openingBalance: 0,
        closingAmount: 0,
        closingQuantity: 0,
      });
      groups.map((item, index) => {
        groups[index]["productList"] = [];
        groups[index]["quantity"] = 0;
        groups[index]["durationQuantity"] = 0;
        groups[index]["durationAmount"] = 0;
        groups[index]["saleQuantity"] = 0;
        groups[index]["durationQtySale"] = 0;
        groups[index]["durationAmountSale"] = 0;
        groups[index]["purchaseQuantity"] = 0;
        groups[index]["durationQtyPurchase"] = 0;
        groups[index]["durationAmountPurchase"] = 0;
        groups[index]['openingQuantity'] = item.weight;
        groups[index]['openingBalance'] = item.openingBalance;

        groups[index]["closingAmount"] = 0;
        groups[index]["closingQuantity"] = 0;
      });
      groups.map((item, index) => {
        products.map((prod) => {
          if (prod.productGroup && prod.productGroup == item[".key"]) {
            groups[index]["productList"] = groups[index]["productList"].concat(
              prod.productList
            );
            groups[index]["quantity"] += Number.parseFloat(prod["quantity"]);
            groups[index]["durationQuantity"] += Number.parseFloat(
              prod["durationQuantity"]
            );
            groups[index]["durationAmount"] += Number.parseFloat(
              prod["durationAmount"]
            );
            groups[index]["saleQuantity"] += Number.parseFloat(
              prod["saleQuantity"]
            );
            groups[index]["durationQtySale"] += Number.parseFloat(
              prod["durationQtySale"]
            );
            groups[index]["durationAmountSale"] += Number.parseFloat(
              prod["durationAmountSale"]
            );
            groups[index]["purchaseQuantity"] += Number.parseFloat(
              prod["purchaseQuantity"]
            );
            groups[index]["durationQtyPurchase"] += Number.parseFloat(
              prod["durationQtyPurchase"]
            );
            groups[index]["durationAmountPurchase"] += Number.parseFloat(
              prod["durationAmountPurchase"]
            );
            // groups[index]["openingQuantity"] += Number.parseFloat(
            //   prod["openingQuantity"]
            // );
            // groups[index]["openingBalance"] += Number.parseFloat(
            //   prod["openingBalance"]
            // );
            groups[index]["closingAmount"] += Number.parseFloat(
              prod["closingAmount"]
            );
            groups[index]["closingQuantity"] += Number.parseFloat(
              prod["closingQuantity"]
            );
          } else if (!prod.productGroup && item[".key"] == "Nongroup") {
            groups[index]["productList"] = groups[index]["productList"].concat(
              prod.productList
            );
            groups[index]["quantity"] += Number.parseFloat(prod["quantity"]);
            groups[index]["durationQuantity"] += Number.parseFloat(
              prod["durationQuantity"]
            );
            groups[index]["durationAmount"] += Number.parseFloat(
              prod["durationAmount"]
            );
            groups[index]["saleQuantity"] += Number.parseFloat(
              prod["saleQuantity"]
            );
            groups[index]["durationQtySale"] += Number.parseFloat(
              prod["durationQtySale"]
            );
            groups[index]["durationAmountSale"] += Number.parseFloat(
              prod["durationAmountSale"]
            );
            groups[index]["purchaseQuantity"] += Number.parseFloat(
              prod["purchaseQuantity"]
            );
            groups[index]["durationQtyPurchase"] += Number.parseFloat(
              prod["durationQtyPurchase"]
            );
            groups[index]["durationAmountPurchase"] += Number.parseFloat(
              prod["durationAmountPurchase"]
            );
            groups[index]["openingQuantity"] += Number.parseFloat(
              prod["openingQuantity"]
            );
            groups[index]["openingBalance"] += Number.parseFloat(
              prod["openingBalance"]
            );
            groups[index]["closingAmount"] += Number.parseFloat(
              prod["closingAmount"]
            );
            groups[index]["closingQuantity"] += Number.parseFloat(
              prod["closingQuantity"]
            );
          }
        });
      });
      //groups.push(total);
      groups.map((prod, index) => {
        groups[index]["closingAmount"] =
         ( Number.parseFloat(prod["openingBalance"]) +
          Number.parseFloat(prod["durationAmountPurchase"]) -
          Number.parseFloat(prod["durationAmountSale"]));
        groups[index]["closingQuantity"] =
          (Number.parseFloat(prod["openingQuantity"]) +
          Number.parseFloat(prod["durationQtyPurchase"]) -
          Number.parseFloat(prod["durationQtySale"]));
      });
      
      let closingAmount = 0;
      let openingBalance = 0;
       groups.map((prod,index) =>{
              groups[index]['quantity'] = Number.parseFloat(prod['quantity']).toFixed(3)
              groups[index]['durationQuantity'] = Number.parseFloat(prod['durationQuantity']).toFixed(3)
              groups[index]['durationAmount'] = Number.parseFloat(prod['durationAmount']).toFixed(3)
              groups[index]['saleQuantity'] = Number.parseFloat(prod['saleQuantity']).toFixed(3)
              groups[index]['durationQtySale'] = Number.parseFloat(prod['durationQtySale']).toFixed(3)
              groups[index]['durationAmountSale'] = Number.parseFloat(prod['durationAmountSale']).toFixed(3)
              groups[index]['purchaseQuantity'] = Number.parseFloat(prod['purchaseQuantity']).toFixed(3)
              groups[index]['durationQtyPurchase'] = Number.parseFloat(prod['durationQtyPurchase']).toFixed(3)
              groups[index]['durationAmountPurchase'] = Number.parseFloat(prod['durationAmountPurchase']).toFixed(3)
              groups[index]['openingQuantity'] = Number.parseFloat(prod['openingQuantity']).toFixed(3)
              groups[index]['openingBalance'] = Number.parseFloat(prod['openingBalance']).toFixed(3)
              groups[index]['closingAmount'] = Number.parseFloat(prod['closingAmount']).toFixed(3)
              groups[index]['closingQuantity'] = Number.parseFloat(prod['closingQuantity']).toFixed(3)
              closingAmount += Number.parseFloat(prod['closingAmount'])
              openingBalance += Number.parseFloat(prod['openingBalance'])
          })
          this.closingStockWeight = Number.parseFloat(closingAmount).toFixed(3)
          this.totalOpeningStockWeight = Number.parseFloat(openingBalance).toFixed(3)

      return groups;
    },
    ITCData(){
        let inputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
      let outputGST = {
        IGST: 0,
        CGST: 0,
        SGST: 0
      };
        let toDate = this.filterInvoiceTo ?  new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        let filteredInvoices = this.invoices.filter(item => item["brand"] === this.selectedBrand &&
        (item.date >= this.finYear.start) && 
        (item.date <= this.finYear.end)
        && item['items']
        && item['items'].length
        && (this.selectedFirm ? item["firm"] == this.selectedFirm['.key'] : true)
        && (this.selectedfromDate ? item.date >= fromDate : true) &&
         (item.deleted != true) &&
          (this.selectedtoDate ? item.date <= toDate : true));
        filteredInvoices.map(invoice => {
            if (invoice.isBuyer) {
              invoice.items && invoice.items.map(item => {
                outputGST.SGST += item.SGST_val
                  ? Number.parseFloat(item.SGST_val)
                  : 0;
                outputGST.CGST += item.CGST_val
                  ? Number.parseFloat(item.CGST_val)
                  : 0;
                outputGST.IGST += item.IGST_val
                  ? Number.parseFloat(item.IGST_val)
                  : 0;
              });
            } else {
              invoice.items && invoice.items.map(item => {
                inputGST.SGST += item.SGST_val
                  ? Number.parseFloat(item.SGST_val)
                  : 0;
                inputGST.CGST += item.CGST_val
                  ? Number.parseFloat(item.CGST_val)
                  : 0;
                inputGST.IGST += item.IGST_val
                  ? Number.parseFloat(item.IGST_val)
                  : 0;
              });
            }
        });

        let returnOBJ = {
          liabilities : {
            SGST : 0,
            CGST : 0,
            IGST : 0
          },
          assets : {
            SGST : 0,
            CGST : 0,
            IGST : 0
          }
        }

        //IGST
        if(Number.parseFloat(outputGST.IGST) < Number.parseFloat(inputGST.IGST)) {
          returnOBJ.assets.IGST = (Number.parseFloat(inputGST.IGST) - (Number.parseFloat(outputGST.IGST) + Number.parseFloat(outputGST.CGST) + Number.parseFloat(outputGST.SGST))).toFixed(2)
        } else {
          returnOBJ.assets.IGST = 0;
        } 

        if((Number.parseFloat(outputGST.IGST) > Number.parseFloat(inputGST.IGST))) {
          returnOBJ.liabilities.IGST = (Number.parseFloat(outputGST.IGST) - (Number.parseFloat(inputGST.IGST))).toFixed(2)
        } else {
          returnOBJ.liabilities.IGST = 0;
        } 

        //CGST
        if(Number.parseFloat(inputGST.CGST) > (Number.parseFloat(outputGST.CGST))) {
          returnOBJ.assets.CGST = (Number.parseFloat(inputGST.CGST) - (Number.parseFloat(outputGST.CGST))).toFixed(2)
        } else {
          returnOBJ.assets.CGST = 0;
        } 

        if(Number.parseFloat(inputGST.CGST) < (Number.parseFloat(outputGST.CGST))) {
          returnOBJ.liabilities.CGST = (Number.parseFloat(outputGST.CGST) - Number.parseFloat(inputGST.CGST)).toFixed(2)
        } else {
          returnOBJ.liabilities.CGST = 0;
        }
        
        
        //SGST
        if(Number.parseFloat(inputGST.SGST) > (Number.parseFloat(outputGST.SGST))) {
          returnOBJ.assets.SGST = (Number.parseFloat(inputGST.SGST) - (Number.parseFloat(outputGST.SGST))).toFixed(2) 
        } else {
          returnOBJ.assets.SGST = 0;
        } 

        if(Number.parseFloat(inputGST.SGST) < (Number.parseFloat(outputGST.SGST) )) {
          returnOBJ.liabilities.SGST = ((Number.parseFloat(outputGST.SGST)) - Number.parseFloat(inputGST.SGST)).toFixed(2)
        } else {
          returnOBJ.liabilities.SGST = 0;
        }
        return returnOBJ;

      },
      accountByBrand () {
        const accounts = this.accounts.filter(account => account.brand === this.selectedBrand);
        if(this.selectedFirm) {
          return accounts.filter(account => account.firm === this.selectedFirm['.key'])  
        }
        return accounts
      },
      // creditorByBrand() {
      //   if(this.creditors) {
      //     return this.creditors.filter(creditor => creditor['brand'] === this.selectedBrand)
      //   }
      //   return [];
      // },
      // customerByBrand() {
      //   if(this.customers) {
      //     return this.customers.filter(customer => customer['brand'] === this.selectedBrand)
      //   }
      //   return [];
      // },
      // list creditor by Id for diff for invoice
      creditorsById() {
        return this.creditorByBrand.map(item => item['.key'])
      },
      // list customer by Id for diff for invoice 
      customersById() {
        return this.customerByBrand.map(item => item['.key'])
      },
      // current brands firm list
      firmsByBrand () {
        // return selected brand firms
        return this.firms
          .filter((item) => item['brand'] === this.selectedBrand)
          .map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
              this.isJwelleryBussiness = item.businessType == "Jwellery"
            }
            return item;
          })
      },
      // all invoice for brand and firms
      invoiceByBrandAndFirm () {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => ((item['brand'] === this.selectedBrand) &&
          (item.date >= this.finYear.start) && 
           (item.deleted != true) &&
                  (item.date <= this.finYear.end)));
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm['.key']);
        }
        if(this.filterInvoiceFrom) {
          const from = new Date(this.filterInvoiceFrom).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.filterInvoiceTo) {
          const to = new Date(this.filterInvoiceTo).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      // all invoice which are credited
      creditedInvoice() { return this.invoiceByBrandAndFirm.filter(invoice => invoice.isCredited) },
      // all invoice which are debited
      debitedInvoice() { return this.invoiceByBrandAndFirm.filter(invoice => !invoice.isCredited) },
      // expense list type by brand
      expenseByBrand() {
        if(!this.expenses) { return [] };
        // return expense with underhead 
        return this.expenses.filter((item) => item['brand'] === this.selectedBrand).map(item => item['.key']);
      },
      liabilityByBrand() {
        if(!this.liabilities) { return [] };
        // return expense with underhead 
        return this.liabilities.filter((item) => item['brand'] === this.selectedBrand).map(item => item['.key']);
      },
      // expense for which expense type is for brands
      invoiceByExpense() {
        return this.invoiceByBrandAndFirm.filter(invoice => {
          if(invoice.expenseType) {
            return this.expenseByBrand.includes(invoice.expenseType)
          }
          return false
        })
      },
      invoiceByLiability() {
        return this.invoiceByBrandAndFirm.filter(invoice => {
          if(invoice.liabilityType) {
            return this.liabilityByBrand.includes(invoice.liabilityType)
          }
          return false
        })
      },
      // total amount for expense by current brand
      invoiceByExpenseTotal() {
        return this.invoiceByExpense.reduce((total, item) => total + item.totalAmount, 0);
      },
      // total amount for liability by current brand
      invoiceByLiabilityTotal() {
        return this.invoiceByLiability.reduce((total, item) => total + item.totalAmount, 0);
      }, 
      // total Profit income from invoice by brand and firms
      invoiceTotalIncome() {
        return this.invoiceByBrandAndFirm.reduce((total, item) => {
          // calculate total Income for expense
          return total + Number.parseFloat(item['profit'] || 0)
        }, 0)
      },
      // for liabilities
      //  closing balance from net propA/C by firms
      propCapitalAC() {
        if(!this.selectedFirm) {
          return 0;
        }
        return this.selectedFirmDetail.openingBalance
      },

      // Start of liability from Transaction Tab
      groupLiabilities(){
          this.liabilityTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let liabilities = this.liabilities.filter(liability => liability.brand === this.selectedBrand && liability.category === "non-current" && liability.underHead === "Long-term Borrowing");
            liabilities = liabilities.filter(liability => !!liability['.key']);
            liabilities.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand 
            && (invoice.date >= this.finYear.start)  
            && (invoice.date <= this.finYear.end)
            && invoice["liabilityType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            liabilities[index]['invoices'] = invoices;
            liabilities[index].paymentTypeStatus = paymentTypeStatus;
            liabilities[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            liabilities[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.liabilityTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.liabilityTotal = Number.parseFloat(this.liabilityTotal).toFixed(2)
        return liabilities;
      },  
      // End of liability From Transaction Tab

      // Start of Short-term liability from Transaction Tab
      groupLiabilitiesShortTerm(){
          this.shortTermLiabilityTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let liabilities = this.liabilities.filter(liability => liability.brand === this.selectedBrand && liability.category === "current" && liability.underHead === "Short-Term Borrowing");
            liabilities = liabilities.filter(liability => !!liability['.key']);
            liabilities.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand
            && (invoice.date >= this.finYear.start) &&
            (invoice.date <= this.finYear.end) && invoice["liabilityType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            liabilities[index]['invoices'] = invoices;
            liabilities[index].paymentTypeStatus = paymentTypeStatus;
            liabilities[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            liabilities[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.shortTermLiabilityTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.shortTermLiabilityTotal = Number.parseFloat(this.shortTermLiabilityTotal).toFixed(2)
        return liabilities;
      },  
      // End of liability From Transaction Tab


      // all invoice for brand with status "open"
      openInvoices() {
        return this.invoiceByBrandAndFirm.filter(item => item.status === 'open')
      },
      // all invoice by creditors
      openInvoiceByCreditor() {
        const invoice = []
        for(let i = 0; i !== this.openInvoices.length; i++){
          // diff invoice by customeId to creditor
          if(this.creditorsById.includes(this.openInvoices[i].customerId)) {
            invoice.push(this.openInvoices[i])
          }
        }
        return invoice;
      },
      // all invoice by customer (debtors)
      openInvoiceByCustomer() {
        const invoice = []
        for(let i = 0; i !== this.openInvoices.length; i++){
          // diff invoice by customeId to customer
          if(this.customersById.includes(this.openInvoices[i].customerId)) {
            invoice.push(this.openInvoices[i])
          }
        }
        return invoice;
      },
      // creditor invoice where item type is gold/silver
      openInvoiceByCreditorSundry() {
        return this.openInvoiceByCreditor.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver'
          }
          return false
        })
      },
      // creditor invoice where item type is "without item"
      openInvoiceByCreditorUnsecured() {
        return this.openInvoiceByCreditor.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === "Without item"
          }
          return false
        })
      },
      
      // creditor invoice where item type is gold/silver
      openInvoiceByCustomerSundry() {
        return this.openInvoiceByCustomer.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === 'Gold' || invoice.items[0].type === 'Silver'
          }
          return false
        })
      },
      // creditor invoice where item type is "without item"
      openInvoiceByCustomerLoanNAdvances() {
        return this.openInvoiceByCustomer.filter(invoice => {
          if(invoice.items && invoice.items[0]) {
            return invoice.items[0].type === "Without item"
          }
          return false
        })
      },
      // Sundry Creditor total: Transaction with item taken by Creditor
      sundryCreditors() {
        return this.openInvoiceByCreditorSundry.reduce((total, item) => total + item.totalAmount, 0)
      },
      sundryCreditorsList() {
        const creditor = {}
        let calculated = []
        try {
          this.openInvoiceByCreditorSundry.forEach(invoice => {
            if(creditor[invoice.customerId]) {
              creditor[invoice.customerId].push(invoice)
            } else {
              creditor[invoice.customerId] = [invoice]
            }
          })
          Object.keys(creditor).forEach(customer => {
            const list = creditor[customer] || []
            calculated.push({
              type: 'creditor',
              invoices: creditor[customer],
              id: customer,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch (e) {
          // console.info(e)
          return calculated
        }
        return calculated
      },
      // Creditors Unsecured Loans Total: landing money without item by Creditor
      unsecuredLoans() {
        return this.openInvoiceByCreditorUnsecured.reduce((total, item) => total + item.totalAmount, 0);
      },
      unsecuredLoansList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCreditorUnsecured.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'creditor',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          // console.info(e)
        }
        return customerList;
      },
      // Debtors Total: Transaction with item taken by Customer(debtors)
      sundryDebtors() {
        return this.openInvoiceByCustomerSundry.reduce((total, item) => total + item.totalAmount, 0)
      },
      sundryDebtorsList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCustomerSundry.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'customer',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          // console.info(e)
        }
        return customerList;
      },
      // landing money without by Customer (debtors)
      loansAndAdvances() {
        return this.openInvoiceByCustomerLoanNAdvances.reduce((total, item) => total + item.totalAmount, 0);
      },
      loansAndAdvancesList() {
        const customers = {}
        let customerList = []
        try {
          this.openInvoiceByCustomerLoanNAdvances.forEach(invoice => {
            if(customers[invoice.customerId]) {
              customers[invoice.customerId].push(invoice)
            } else {
              customers[invoice.customerId] = [invoice]
            }
          })
          Object.keys(customers).forEach(items => {
            const list = customers[items] || []
            customerList.push({
              type: 'customer',
              invoices: customers[items],
              id: items,
              amount: list.reduce((total, item) => total + item.totalAmount, 0),
            })
          })
        } catch(e) {
          // console.info(e)
        }
        return customerList;
      },
      // bank with list
      securedLoansBankList() {
        return this.accountByBrand.filter(bank => bank.accountType === 'Loan A/C' || bank.accountType === 'Overdraft A/C')
      },
      // Total of amount of secured loans bank
      securedLoansBankListTotal() {
        return this.securedLoansBankList.reduce((total, bank) => total + bank.amount, 0);
      },
      // secured account bank list
      savingsCurrentBankList() {
        return this.accountByBrand.filter(bank => 
        (bank.accountType === 'Saving A/C' || bank.accountType === 'Current A/C')) 
        // && (bank.openingDate ? ((bank.openingDate >= new Date(this.finYear.start).getTime()) && (bank.openingDate <= new Date(this.finYear.end).getTime())) : false ))
      },
      // total of amount of saving/current bank account
      savingsCurrentBankListTotal() {
        // return this.savingsCurrentBankList.reduce((total, bank) => total + bank.amount, 0);
        let amount = 0;
        this.savingsCurrentBankList.map((bank) => {
          // let openingDate = new Date(bank.openingDate).getTime();
          amount += Number.parseFloat(bank.amount);
          });
        return amount;
      },
      // cash in hand: firms available cash
      cashInHand() {
        if(this.selectedFirm) {
          // return firm.item.amount
          // let openingDate = new Date(this.selectedFirm.openingDate).getTime();
          return (Number.parseFloat(this.selectedFirm.amount));
        }
        return this.firmsByBrand.reduce((balance, firm) => {
          // let openingDate = new Date(this.selectedFirm.openingDate).getTime();
          let amount = Number.parseFloat(firm.amount);
          return balance = balance + amount;
          // return balance = balance + firm.item.amount
        }, 0)
      },
      totalAssetAmount() {
        return this.getAssetAccount.reduce((total, item) => {
          // return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((item.details.depriciation) /100) || 0)  + total
          return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((this.isDepriciation  ? item.details.depriciation : 0) /100) || 0)  + total
        }, 0)
      },
      totalInvestmentAmount() {
        return this.getInvestmentAccount.reduce((total, item) => {
          return item.details.totalAmount + item.details.openingBalance  + total
        }, 0)
      },
      totalIntangibleAssetAmount() {
        return this.getIntangibleAssetAccount.reduce((total, item) => {
          // return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((item.details.depriciation) /100) || 0)  + total
          return (item.details.totalAmount + item.details.openingBalance) - ((item.details.totalAmount + item.details.openingBalance) * ((this.isDepriciation  ? item.details.depriciation : 0) /100) || 0)  + total
        }, 0)
      },
      // totalIntangibleAssetAmount() {
      //   return this.getIntangibleAssetAccount.reduce((total, item) => {
      //     return item.details.totalAmount + item.details.openingBalance  + total
      //   }, 0)
      // },
      assetAsFixedByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => (item['brand'] === this.selectedBrand && item.type != 'investments') && (item['brand'] === this.selectedBrand && item.type != 'intangibleAssets'));
      },
      assetAsInvestmentByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type === 'investments');
      },
      assetAsIntangibleByBrand() {
        if(!this.assets) { return [] };
        // return asset with underhead 
        return this.assets.filter((item) => item['brand'] === this.selectedBrand && item.type === 'intangibleAssets');
      },
      invoiceByBrand() {
        if(!this.invoices) { return [] };
        let filter = this.invoices.filter((item) => (item['brand'] === this.selectedBrand) &&
         (item.deleted != true) &&
         (item.date >= this.finYear.start) && (item.date <= this.finYear.end));
        if(this.selectedFirm) {
          filter = filter.filter(item => item.firm === this.selectedFirm['.key']);
        }
        if(this.filterInvoiceFrom) {
          const from = new Date(this.filterInvoiceFrom).setHours(0,0,0,0);
          filter = filter.filter(item => item.date >= from)
        }
        if(this.filterInvoiceTo) {
          const to = new Date(this.filterInvoiceTo).setHours(23,29,59,999);
          filter = filter.filter(item => item.date <= to)
        }
        return filter;
      },
      getAssetAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetAsFixedByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm['.key']
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          // console.info(e)
          return []
        }
      },
      getInvestmentAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetAsInvestmentByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm['.key']
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          // console.info(e)
          return []
        }
      },

      // Intangible assets 
      getIntangibleAssetAccount() {
        const mainGroup = [] // { details: {} && invoices: []}
        try {
          this.assetAsIntangibleByBrand.forEach(details => {
            const invoices = this.invoiceByBrand.filter(invoice => {
              if(this.selectedFirm) {
                // return invoice of selected firmId
                return invoice.assetType === details['.key'] && invoice.firm === this.selectedFirm['.key']
              }
              // return all matched key invoices
              return invoice.assetType === details['.key'];
            })
            details.totalAmount = invoices.reduce((total, item) => {
              return total + item.totalAmount  
            }, 0)
            details.openingBalance = invoices.reduce((total, item) => {
              return total + item.openingBalance 
            }, 0)
            if(details.totalAmount) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
            else if (details.openingBalance) {
              mainGroup.push({
                details,
                invoices
              }) 
            }
          })
          return mainGroup
        } catch(e) {
          // console.info(e)
          return []
        }
      },

      // group Expenses of Prop Capital
      groupExpensesOfPropCapital(){
          this.propexpenseTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand &&  expense.underHead === 'Prop Capital A/C' && expense.category === "Indirect");
            expenses = expenses.filter(expense => !!expense['.key']);
            expenses.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true)
             && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            expenses[index]['invoices'] = invoices;
            expenses[index].paymentTypeStatus = paymentTypeStatus;
            expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.propexpenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.propexpenseTotal = Number.parseFloat(this.propexpenseTotal).toFixed(2)
          return expenses;
        },

        // Group Incomes Of Prop Capital
        groupIncomesOfPropCapital(){
        this.propincomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand &&  income.underHead === 'Prop Capital A/C' && income.category === "Indirect")
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true) && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.propincomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.propincomeTotal = Number.parseFloat(this.propincomeTotal).toFixed(2)
          return incomes;
        },
        

        // Start Functionality of Dep Assets in Profit and Loss A/C
        plassetByBrand() {
         if (this.assets) {
          this.pltotalAsset = 0;
          let toDate = this.filterInvoiceTo ?  new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          // let selectedAssets = this.assets.filter(asset => {
          //   return asset.brand === this.selectedBrand && (this.selectedFirmDetail ? this['firm']  === this.selectedFirmDetail['.key'] : true)  && asset['category'] != 'personal' && asset['depriciation']    
          // });
          let selectedAssets = this.assets.filter(asset => {
            return asset.brand === this.selectedBrand && asset['category'] != 'personal' && asset['depriciation']    
          });
          selectedAssets.map((ast,index)=>{
            let firmAsset = this.invoices.filter(item => 
              item['assetType'] === ast['.key'] &&
              item['brand'] === this.selectedBrand 
               && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
              (this.selectedFirmDetail ? item['firm'] === this.selectedFirmDetail['.key'] : true) &&
              (fromDate ? invoice.date >= fromDate : true) &&
              (toDate ? invoice.date <= toDate : true))
              let openingBalance = 0;
              let totalAmount = 0;
              firmAsset.map((inv)=>{
                  openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
                  totalAmount += (inv.totalAmount ? parseInt(inv.totalAmount) : 0);
              });
              selectedAssets[index]['openingBalance'] = openingBalance;
              selectedAssets[index]['totalAmount'] = totalAmount;
              selectedAssets[index]['depAmount'] = this.getDepAmount(ast,ast.type);
              if(ast.category ==='b&p') {
                selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount']/2;
              }
              this.pltotalAsset += selectedAssets[index]['depAmount'];
            })
            return selectedAssets;
            }
          return [];
        },
        // End functionality of Dep Assets in Profit and Loss A/C
        
       
       // Start Functionality of Dep Assets in Prop Capital A/C 
        propassetByBrand() {
         if (this.assets) {
          this.proptotalAsset = 0;
          let toDate = this.filterInvoiceTo ?  new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          // let selectedAssets = this.assets.filter(asset => {
          //   return asset.brand === this.selectedBrand && (this.selectedFirmDetail ? this['firm']  === this.selectedFirmDetail['.key'] : true)  && asset['category'] != 'business' && asset['depriciation']    
          // });
          let selectedAssets = this.assets.filter(asset => {
            return asset.brand === this.selectedBrand && asset['category'] != 'business' && asset['depriciation']    
          });
          selectedAssets.map((ast,index)=>{
            let firmAsset = this.invoices.filter(item => 
              item['assetType'] === ast['.key'] &&
              item['brand'] === this.selectedBrand 
               && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&
              (this.selectedFirmDetail ? item['firm'] === this.selectedFirmDetail['.key'] : true)&&
              (fromDate ? invoice.date >= fromDate : true) &&
              (toDate ? invoice.date <= toDate : true))
              let openingBalance = 0;
              let totalAmount = 0;
              firmAsset.map((inv)=>{
                  openingBalance += (inv.openingBalance ? parseInt(inv.openingBalance) : 0);
                  totalAmount += (inv.totalAmount ? parseInt(inv.totalAmount) : 0);
              });
              selectedAssets[index]['openingBalance'] = openingBalance;
              selectedAssets[index]['totalAmount'] = totalAmount;
              selectedAssets[index]['depAmount'] = this.getDepAmount(ast,ast.type);
              if(ast.category ==='b&p') {
                selectedAssets[index]['depAmount'] = selectedAssets[index]['depAmount']/2;
              }
              this.proptotalAsset += selectedAssets[index]['depAmount'];
            })
            return selectedAssets;
            }
          return [];
        },        
        // End functionality of Dep Assets in Profit and Loss A/C

        // Group Expenses of Trading Account
        groupExpensesOfTradingAccount(){
            this.tradingexpenseTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand && expense.category === "Direct");
            expenses = expenses.filter(expense => !!expense['.key']);
            expenses.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true)  && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            expenses[index]['invoices'] = invoices;
            expenses[index].paymentTypeStatus = paymentTypeStatus;
            expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.tradingexpenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.tradingexpenseTotal = Number.parseFloat(this.tradingexpenseTotal).toFixed(2)
          return expenses;
        },

        // Group Income of Trading account
        groupIncomesOfTradingAccount(){
        this.tradingincomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand && income.category === "Direct");
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true)  && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
            paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.tradingincomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.tradingincomeTotal = Number.parseFloat(this.tradingincomeTotal).toFixed(2)
          return incomes;
        },

        // Group Incomes of Profit and Loss
        groupIncomesOfPl(){
            this.pandlincomeTotal = 0;
            let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
            let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            let incomes = this.incomes.filter(income => income.brand === this.selectedBrand && income.underHead === 'Profit and Loss' && income.category === "Indirect");
            incomes = incomes.filter(income => !!income['.key']);
            incomes.map((ex,index)=>{
            let openingBalance = 0;
            let totalAmount = 0;
            let paymentTypeStatus = 'confirm';
            let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true)  && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
            invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
                paymentTypeStatus = inv.paymentTypeStatus;
            }
            });
            incomes[index]['invoices'] = invoices;
            incomes[index].paymentTypeStatus = paymentTypeStatus;
            incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
            incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
            this.pandlincomeTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
            })
            this.pandlincomeTotal = Number.parseFloat(this.pandlincomeTotal).toFixed(2)
            return incomes;
        },

        // Group Expense of Profit and Loss
        groupExpensesOfPandL(){
          this.pandlexpenseTotal = 0;
          let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand && expense.underHead === 'Profit and Loss' && expense.category === "Indirect");
          expenses = expenses.filter(expense => !!expense['.key']);
          expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
          (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true)  && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) &&
          (fromDate ? invoice.date >= fromDate : true) &&
          (toDate ? invoice.date <= toDate : true))
          invoices.map((inv)=>{
          openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
          totalAmount += Number.parseFloat(inv.totalAmount)
          if(paymentTypeStatus == 'confirm') {
          paymentTypeStatus = inv.paymentTypeStatus;
          }
          });
          expenses[index]['invoices'] = invoices;
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          this.pandlexpenseTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
          })
          this.pandlexpenseTotal = Number.parseFloat(this.pandlexpenseTotal).toFixed(2)
        return expenses;
      },


      // staff account in profit and loss  
      getStaffAccount () {
        this.totalSalary = 0;
            if (this.selectedBrand) {
              const staffList = this.staff.filter(item => item['brand'] === this.selectedBrand && (this.selectedFirm ? item['firm']  === this.selectedFirm['.key'] : true))      
                const result = staffList.map(e => {
                    const salaryList = _.filter(this.salarys, { 'staffId': e['.key'], });
                    e.salaryList = salaryList;
                    const creditTotal = _.sumBy(salaryList, function (s) {
                        if(s.isCredited)
                            return s.amount
                    });

                    e.creditTotal = creditTotal ? creditTotal :0;

                    const debitTotal = _.sumBy(salaryList, function (s) {
                        if(!s.isCredited)
                            return s.amount
                    });

                     e.debitTotal = debitTotal ? debitTotal : 0;
          
                     this.totalSalary = this.totalSalary + ( parseInt(e.creditTotal) - parseInt(e.debitTotal) ) ;
                    return e;
                })
                // console.log(result,null,4)
                return result;
            }
        },

        // Sale record from Trading account
        sales(){
          let totalSale = 0;
          let buyers = this.buyers.filter(item => item["brand"] === this.selectedBrand);
          let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
          buyers.map((buyer)=>{
              let sales = this.invoices.filter((item) => 
              item['brand'] === this.selectedBrand  && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
              item['buyerId'] == buyer['.key'] &&
              (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
              (fromDate ? item.date >= fromDate : true) &&
              (toDate ? item.date <= toDate : true));
            sales.map((inv)=>{
              totalSale += (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
            })
          })
          totalSale = Number.parseFloat(totalSale).toFixed(2);
          return totalSale;
        },

        // Purchase record from Trading account
        purchase(){
          let totalPurchase = 0;
          let sellers = this.sellers.filter(item => item["brand"] === this.selectedBrand);
          let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
          let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
            sellers.map((buyer)=>{
            let purchase = this.invoices.filter((item) => 
            item['brand'] === this.selectedBrand && (item.date >= this.finYear.start) && (item.date <= this.finYear.end) &&  
            item['buyerId'] == buyer['.key'] &&
            (item.deleted != true) &&
            (this.selectedFirm ? item['firm'] === this.selectedFirm['.key'] : true) &&
            (fromDate ? item.date >= fromDate : true) &&
            (toDate ? item.date <= toDate : true));
            purchase.map((inv)=>{
              totalPurchase += (inv.totalAmount ? Number.parseFloat(inv.totalAmount) : 0)
            })
          })
          totalPurchase = Number.parseFloat(totalPurchase).toFixed(2);
          return totalPurchase;
      },

      // Closing Stock fethced from "Prop Capital Account"
      closingBalance() {
        let propclosing = ((this.selectedFirmDetail ? (Number.parseFloat(this.selectedFirmDetail.openingBalance) || 0) : 0) + Number.parseFloat(this.propincomeTotal) + Number.parseFloat(this.netProfit)  - (Number.parseFloat(this.proptotalAsset) + Number.parseFloat(this.propexpenseTotal)))
        propclosing = Number.parseFloat(propclosing).toFixed(2)
        return propclosing;
      },

      // Closing Stock fethced from "Trading Account "
      // closingStock(){
      //   let closingstock =  (((this.selectedFirmDetail ? (Number.parseFloat(this.selectedFirmDetail.openingStock) || 0) : 0) + 
      //   Number.parseFloat(this.purchase || 0 | amount)) - (
      //   Number.parseFloat(this.sales || 0 | amount)));
      //   closingstock = Number.parseFloat(closingstock).toFixed(2)
      //   return closingstock;
      // },


      // Gross profit fethced from "Trading Account "
      // grossProfit(){
      //   let profit = (( Number.parseFloat(this.sales) + Number.parseFloat(this.tradingincomeTotal) + Number.parseFloat((this.isJwelleryBussiness
      //             ? this.closingStockWeight
      //             : this.closingStock)))
      //   - ((this.selectedFirmDetail ? (Number.parseFloat(this.selectedFirmDetail.openingStock) || 0) : 0) + 
      //     Number.parseFloat(this.purchase) +  Number.parseFloat(this.tradingexpenseTotal))
      //   ); 
      //   profit = Number.parseFloat(profit).toFixed(2);
      //   return profit;
      // },
      grossProfit() {
      let profit =
        Number.parseFloat(this.sales) +
        Number.parseFloat(this.incomeTotal) +
        Number.parseFloat((this.isJwelleryBussiness
          ? this.closingStock
          : this.closingStockWeight)) -
        ((this.selectedFirm
          ? Number.parseFloat(this.selectedFirm.openingStock) || 0
          : 0) +
          Number.parseFloat((this.isJwelleryBussiness
          ? this.totalOpeningStockWeight
          : this.totalOpeningStock)) +
          Number.parseFloat(this.purchase) +
          Number.parseFloat(this.expenseTotal));
      profit = Number.parseFloat(profit).toFixed(2);
      return profit;
    },

      // net profit fethced from " Profit and Loss A/C "
      netProfit(){
        let netprofit = (
          (Number.parseFloat(this.pandlincomeTotal) + Number.parseFloat(this.grossProfit))
          - (Number.parseFloat(this.pandlexpenseTotal) + Number.parseFloat(this.totalSalary) + Number.parseFloat(this.pltotalAsset))    
        )
        netprofit = Number.parseFloat(netprofit).toFixed(2);
        return netprofit;
      },

      expenseWithProvision(){
        this.expenseProvisionTotal = 0;
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        let expenses = this.expenses.filter(expense => expense.brand === this.selectedBrand && expense.paymentTypeStatus === 'yet to confirm');
        expenses = expenses.filter(expense => !!expense['.key']);
        expenses.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          // let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand &&  invoice["expenseType"] === ex['.key'])
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["expenseType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) && 
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
          // console.log(invoices)
          invoices.map((inv)=>{
            if(inv.paymentTypeStatus == 'yet to confirm'){
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            }
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          expenses[index].paymentTypeStatus = paymentTypeStatus;
          expenses[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          expenses[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          if(expenses[index].paymentTypeStatus == 'yet to confirm') {
            // console.log(totalAmount)
            //this.expenseProvisionTotal = isNaN(totalAmount) ? this.expenseProvisionTotal : Number.parseFloat(this.expenseProvisionTotal) + Number.parseFloat(totalAmount);
            this.expenseProvisionTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
          }
        })
        this.expenseProvisionTotal = Number.parseFloat(this.expenseProvisionTotal);
        return expenses;
      },
      // End of all Functionality of in Balance sheet // 
    },
    data: () => ({ 
      isDepriciation : true,
      expenseTotal : 0,
      pandlexpenseTotal: 0,
      propexpenseTotal: 0,
      incomeTotal : 0,
      tradingexpenseTotal : 0,
      tradingincomeTotal : 0,
      pandlincomeTotal: 0,
      propincomeTotal: 0,
      proptotalAsset : 0,
      pltotalAsset:0,
      selectedFirm: null,
      filterInvoiceFrom: null,
      filterInvoiceTo: null,
      fromdatepicker: false,
      todatepicker: false,
      searchInput: null,
      totalSundryCreditors : 0,
      totalSundryDebitors : 0,
      totalLoan : 0,
      totalSalary : 0,
      totalLoanAndAdvances : 0,
      expenseProvisionTotal:0,
      buyerList : [],
      sellerList : [],
      incomesWPro : [],
      searchInput: null,
      selectedStaff : {},
      salaryListHeaders: [
                { text: 'Date', value: 'date', sortable: true},
                { text: 'Credit/Debit', value: 'amount', sortable: false},
      ],
      sale : {
          total : 0,
          list : [],
          expand : false
      },
      closingStock : 0,
      isJwelleryBussiness : false,
      closingStockWeight : 0,
     }),
    methods: {
      getClosingAmount(item) {
      let closingQty = (parseInt(item['openingQuantity'] ? item['openingQuantity'] : 0) + parseInt(item['durationQtyPurchase'] ? item['durationQtyPurchase'] : 0)) - parseInt(item['durationQtySale'] ? item['durationQtySale'] : 0)
      switch(this.firmStockReportType) {
        
        case 'APP' :{
          let amount = 0;
          if(item.stockReportData) {
          let avgPurchasePrice = (item.stockReportData.purchaseDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.purchaseDetails.length;
          amount = (avgPurchasePrice * closingQty);
          }
          return amount;
        }
        case 'LPP' :{
          let amount = 0;
          if(item.stockReportData) {
            amount = (item.stockReportData.lastPurchasePrice * closingQty);
          }
          return amount;
        }
        case 'LSP' :{
          let amount = 0;
          if(item.stockReportData) {
            amount = (item.stockReportData.lastSalePrice * closingQty);
          }
          return amount;
        }
        case 'ASP' :{
          let amount = 0;
          if(item.stockReportData) {
            let avgSalePrice = (item.stockReportData.saleDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.saleDetails.length;
            amount = (avgSalePrice * closingQty);
          }
          return amount;
        }
        case 'FIFO' :{
          let amount = 0;
          if(item.stockReportData) {
            let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
              return -(new Date(b.date) - new Date(a.date));
            });

            let qntTemp = closingQty;
            allTransaction.map((t)=>{
              if(qntTemp>t.quantity) {
                amount += (t.quantity * t.rate);
                qntTemp = qntTemp-t.quantity
              } else if(qntTemp > 0) {
                amount += (t.quantity-qntTemp * t.rate);
                qntTemp = 0;
              }
            })        
          }
          return amount;
        }
        case 'LIFO' :{
          let amount = 0;
          if(item.stockReportData) {
            let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
              return new Date(b.date) - new Date(a.date);
            });
            let qntTemp = closingQty;
            allTransaction.map((t)=>{
              if(qntTemp>t.quantity) {
                amount += (t.quantity * t.rate);
                qntTemp = qntTemp-t.quantity
              } else if(qntTemp > 0) {
                amount += (t.quantity-qntTemp * t.rate);
                qntTemp = 0;
              }
            })
          }
          return amount;
        }
      }
    },
      print(){
        let data = [];
        $(".print-field").each(function( index ) {
          data.push($( this ).text())
        });
        let doc = convertToPDFBalanceSheet({data});
        pdfMake.createPdf(doc).download();
      },
      getName(key, property, name) {
        const dd = this[property].find(item => item['.key'] === key);
        if(dd) {
          return dd[name] || key
        }
        return key
      },
      // getFirmName(e){
      //   let firm;
      //     if (this.firms && this.selectedBrand) {
      //       firm =this.firms.filter(item => item['.key'] === e)[0]
      //     }
      //     if(firm)
      //     return firm.name
      // },
      getDepAmount(asset, type) {
        let depriciation = null;
        if (asset.isVerified && asset.depriciation) {
          const totalAmount = this.getTotalAmount(asset);
          depriciation = Number((totalAmount * asset.depriciation) / 100);
          return depriciation;
        }
        return 0;
      },
      getTotalAmount(asset) {
        if (asset.isVerified) {
            return (
                Number(asset.openingBalance || 0) +
                Number(asset.totalAdditionAmount) -
                Number(asset.totalDeletionAmount)
            );
        }
        return (
            Number(asset.totalAdditionAmount) - Number(asset.totalDeletionAmount)
        );
      },
      getData(){
        // this.sellersByBrand();
        // this.BuyersByBrand();
        this.usersByBrand();
        // this.expenseWithProvision();
        this.incomeWithProvision();
        this.liabilityWithProvision();
      },
    
      // Income with Provision 
      incomeWithProvision(){
        this.incomeProvisionTotal = 0;
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        let incomes = this.incomes.filter(income => income.brand === this.selectedBrand && income.paymentTypeStatus === 'yet to confirm');
        incomes = incomes.filter(income => !!income['.key']);
        incomes.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          // let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand &&  invoice["incomeType"] === ex['.key'])
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["incomeType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) && 
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
          // console.log(invoices)
          invoices.map((inv)=>{
            if(inv.paymentTypeStatus == 'yet to confirm'){
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            }
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          incomes[index].paymentTypeStatus = paymentTypeStatus;
          incomes[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          incomes[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          if(incomes[index].paymentTypeStatus == 'yet to confirm') {
            // console.log(totalAmount)
            //this.incomeProvisionTotal = isNaN(totalAmount) ? this.incomeProvisionTotal : Number.parseFloat(this.incomeProvisionTotal) + Number.parseFloat(totalAmount);
            this.incomeProvisionTotal += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
          }
        })
        this.incomeProvisionTotal = Number.parseFloat(this.incomeProvisionTotal);
        this.incomesWPro = incomes;
      },

      // Liability With Provision
      liabilityWithProvision(){
        this.liabilityTotalWPro = 0;
        let toDate = this.filterInvoiceTo ? new Date(this.filterInvoiceTo).getTime() : null;
        let fromDate = this.filterInvoiceFrom ? new Date(this.filterInvoiceFrom).getTime() : null;
        let liabilities = this.liabilities.filter(liability => liability.brand === this.selectedBrand);
        liabilities = liabilities.filter(liability => !!liability['.key']);
        liabilities.map((ex,index)=>{
          let openingBalance = 0;
          let totalAmount = 0;
          let paymentTypeStatus = 'confirm';
          // let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["liabilityType"] === ex['.key']
          // )
          let invoices = this.invoices.filter(invoice => invoice.brand === this.selectedBrand && invoice["liabilityType"] === ex['.key'] && 
            (this.selectedFirm ? invoice['firm'] === this.selectedFirm['.key'] : true) && (invoice.date >= this.finYear.start) && (invoice.date <= this.finYear.end) && 
            (fromDate ? invoice.date >= fromDate : true) &&
            (toDate ? invoice.date <= toDate : true))
          // console.log(invoices)
          invoices.map((inv)=>{
            openingBalance += (inv.openingBalance ? Number.parseFloat(inv.openingBalance) : 0)
            totalAmount += Number.parseFloat(inv.totalAmount)
            if(paymentTypeStatus == 'confirm') {
              paymentTypeStatus = inv.paymentTypeStatus;
            }
          });
          liabilities[index].paymentTypeStatus = paymentTypeStatus;
          liabilities[index].totalAmount = isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount).toFixed(2);
          liabilities[index].openingBalance = isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance).toFixed(2);
          if(liabilities[index].paymentTypeStatus == 'yet to confirm') {
            // console.log(totalAmount)
            //this.liabilityTotalWPro = isNaN(totalAmount) ? this.liabilityTotalWPro : Number.parseFloat(this.liabilityTotalWPro) + Number.parseFloat(totalAmount);
            this.liabilityTotalWPro += (isNaN(openingBalance) ? 0 :Number.parseFloat(openingBalance)) + (isNaN(totalAmount) ? 0 :  Number.parseFloat(totalAmount));
          }
        })
        this.liabilityTotalWPro = Number.parseFloat(this.liabilityTotalWPro);
        this.liabilitiesWPro = liabilities;
      },
      // BuyersByBrand() {
      //   if(this.buyers) {
      //     this.totalSundryDebitors = 0;
      //     this.totalLoanAndAdvances = 0;
      //     this.buyerList = this.buyers.filter(customer => customer['brand'] === this.selectedBrand);
      //     this.buyerList.map((seller,index)=>{
      //         this.buyerList[index]['totalDiscount'] = 0;
      //         this.buyerList[index]['totalDueAmount'] = 0;
      //         this.buyerList[index]['totalAdvance'] = 0;
      //         this.buyerList[index]['totalSecurity'] = 0;
      //         this.buyerList[index]['totalOpeningBal'] = 0;
      //         this.buyerList[index]['totalLoan'] = 0;
      //         this.buyerList[index]['totalRemainingAmount'] = 0;
      usersByBrand() {
        if(this.sellers) {
          this.totalLoan = 0;
          this.totalLoanAndAdvances = 0;
          this.totalSundryCreditors = 0;
          this.sellerList = this.sellers.filter(customer => customer['brand'] === this.selectedBrand);
          this.sellerList.map((seller,index)=>{
              this.sellerList[index]['totalDiscount'] = 0;
              this.sellerList[index]['totalDueAmount'] = 0;
              this.sellerList[index]['totalAdvance'] = 0;
              this.sellerList[index]['totalSecurity'] = 0;
              this.sellerList[index]['totalOpeningBal'] = 0;
              this.sellerList[index]['totalLoanGiven'] = 0;
              this.sellerList[index]['totalLoanTaken'] = 0;
              let invoices  = this.invoices.filter(
                  item =>
                    item["brand"] === this.selectedBrand &&
                    item["buyerId"] === seller['.key'] &&
                    (item.deleted != true) 
                    // && (item.date >= this.finYear.start) 
                    // && (item.date <= this.finYear.end) 
                    && (item["status"] === "due" || item["status"] === "partial") &&
                    (this.selectedFirm
                      ? item["firm"] === this.selectedFirm['.key']
                      : true)
                );
              invoices.map((inv) => {
                //console.log(this.buyerList[index]['totalDueAmount'])
                //this.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? Number.parseFloat(inv.remainingAmount) : 0;
                // this.buyerList[index]['totalDiscount'] += inv.discountAmount ? Number.parseFloat(inv.discountAmount) : 0;
                this.sellerList[index]['totalDueAmount'] += Number.parseFloat(inv.remainingAmount);
                this.sellerList[index]['totalDiscount'] += Number.parseFloat(inv.discountAmount);
              });

              let advanceInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Advance" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              advanceInv.map((inv)  => {
                this.sellerList[index]['totalAdvance'] += Number.parseFloat(inv.remainingAmount);
              });

              let securityInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Security" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              securityInv.map((inv)  => {
                this.sellerList[index]['totalSecurity'] += Number.parseFloat(inv.remainingAmount);
              });

              let openingInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Opening Balance" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              openingInv.map((inv)  => {
                this.sellerList[index]['totalOpeningBal'] += Number.parseFloat(inv.remainingAmount);
              });

              let loanInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  item["type"] === "LoanGiven" &&
                  item["status"] != "paid" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInv.map((inv)  => {
                // this.sellerList[index]['totalLoanGiven'] = inv.amount;
                this.sellerList[index]['totalLoanGiven'] += Number.parseFloat(inv.amount);
              });
              let loanInvTkn = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "LoanTaken" &&
                  (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  item["status"] != "paid" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInvTkn.map((inv)  => {
                //this.sellerList[index]['totalLoanTaken'] = inv.amount;
                this.sellerList[index]['totalLoanTaken'] += Number.parseFloat(inv.amount);

              });
              this.totalLoan += Number.parseFloat(this.sellerList[index]['totalLoanTaken']);
              this.totalLoanAndAdvances += Number.parseFloat(this.sellerList[index]['totalLoanGiven']);
              this.sellerList[index]['totalRemainingAmount'] = (Number.parseFloat(this.sellerList[index]['totalOpeningBal']) + Number.parseFloat(this.sellerList[index]['totalDueAmount'])) - (Number.parseFloat(this.sellerList[index]['totalAdvance']) + Number.parseFloat(this.sellerList[index]['totalSecurity']) + Number.parseFloat(this.sellerList[index]['totalDiscount']));
              this.totalSundryCreditors += Number.parseFloat(this.sellerList[index]['totalRemainingAmount']);
          });
        }
      // },
      // sellersByBrand() {
      //   if(this.sellers) {
      //     this.totalLoan = 0;
      //     this.totalSundryCreditors = 0;
      //     this.sellerList = this.sellers.filter(customer => customer['brand'] === this.selectedBrand);
      //     this.sellerList.map((seller,index)=>{
      //         this.sellerList[index]['totalDiscount'] = 0;
      //         this.sellerList[index]['totalDueAmount'] = 0;
      //         this.sellerList[index]['totalAdvance'] = 0;
      //         this.sellerList[index]['totalSecurity'] = 0;
      //         this.sellerList[index]['totalOpeningBal'] = 0;
      //         this.sellerList[index]['totalLoan'] = 0;
      if(this.buyers) {
        this.totalSundryDebitors = 0;
        // this.totalLoan = 0;
        // this.totalLoanAndAdvances = 0;
        this.buyerList = this.buyers.filter(customer => customer['brand'] === this.selectedBrand);
        this.buyerList.map((seller,index)=>{
        this.buyerList[index]['totalDiscount'] = 0;
        this.buyerList[index]['totalDueAmount'] = 0;
        this.buyerList[index]['totalAdvance'] = 0;
        this.buyerList[index]['totalSecurity'] = 0;
        this.buyerList[index]['totalOpeningBal'] = 0;
        this.buyerList[index]['totalLoanTaken'] = 0;
        this.buyerList[index]['totalLoanGiven'] = 0;
        this.buyerList[index]['totalRemainingAmount'] = 0;
            let invoices  = this.invoices.filter(
                  item =>
                    item["brand"] === this.selectedBrand &&
                    item["buyerId"] === seller['.key'] 
                    // && (item.date >= this.finYear.start) 
                    // && (item.date <= this.finYear.end) 
                    && (item.deleted != true) &&
                    (item["status"] === "due" || item["status"] === "partial") &&
                    (this.selectedFirm
                      ? item["firm"] === this.selectedFirm['.key']
                      : true)
            );
            
            invoices.map((inv) => {
              // this.buyerList[index]['totalDueAmount'] += Number.parseFloat(inv.remainingAmount);
              // this.buyerList[index]['totalDiscount'] += Number.parseFloat(inv.discountAmount);
              // console.log(this.buyerList[index]['totalDueAmount'])
              this.buyerList[index]['totalDueAmount'] += inv.remainingAmount ? Number.parseFloat(inv.remainingAmount) : 0;
              this.buyerList[index]['totalDiscount'] += inv.discountAmount ? Number.parseFloat(inv.discountAmount) : 0;
            });

            let advanceInv = this.customerDeposit.filter(
              item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Advance" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              advanceInv.map((inv)  => {
                this.buyerList[index]['totalAdvance'] += Number.parseFloat(inv.remainingAmount);
              });

              let securityInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Security" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              securityInv.map((inv)  => {
                this.buyerList[index]['totalSecurity'] += Number.parseFloat(inv.remainingAmount);
              });

              let openingInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "Opening Balance" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  !!item["isUserCreated"] && 
                  (parseInt(item["remainingAmount"]) > 0) && 
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              openingInv.map((inv)  => {
                this.buyerList[index]['totalOpeningBal'] += Number.parseFloat(inv.remainingAmount);
              });

              let loanInv = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "LoanTaken" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  item["status"] != "paid" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInv.map((inv)  => {
                // this.buyerList[index]['totalLoanTaken'] = inv.amount;
                this.buyerList[index]['totalLoanTaken'] += Number.parseFloat(inv.amount);
              });

              let loanInvGV = this.customerDeposit.filter(
                item =>
                  item["brand"] === this.selectedBrand &&
                  item["buyerId"] === seller['.key'] &&
                  item["type"] === "LoanGiven" &&
                    (item.date >= this.finYear.start) && (item.date <= this.finYear.end) && 
                  item["status"] != "paid" &&
                  (this.selectedFirm
                    ? item["firm"] === this.selectedFirm['.key']
                    : true)
                );
              loanInvGV.map((inv)  => {
                // this.buyerList[index]['totalLoanGiven'] = inv.amount;
                this.buyerList[index]['totalLoanGiven'] += Number.parseFloat(inv.amount);
              });
            
            this.totalLoan += Number.parseFloat(this.buyerList[index]['totalLoanTaken']);
            this.totalLoanAndAdvances += Number.parseFloat(this.buyerList[index]['totalLoanGiven']);
            this.buyerList[index]['totalRemainingAmount'] = (Number.parseFloat(this.buyerList[index]['totalOpeningBal']) + Number.parseFloat(this.buyerList[index]['totalDueAmount'])) - (Number.parseFloat(this.buyerList[index]['totalAdvance']) + Number.parseFloat(this.buyerList[index]['totalSecurity']) + Number.parseFloat(this.buyerList[index]['totalDiscount']));
            this.totalSundryDebitors += Number.parseFloat(this.buyerList[index]['totalRemainingAmount']);
          });
        }
      },
    }
  }
</script>
<style>
.v-data-iterator.balance .v-expansion-panel__header__icon {
  display: none;
}
.v-data-iterator.balance .v-expansion-panel__header {
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Informations/Bsheet/Bsheet.vue